import React, { useEffect, useState } from "react";
import Input from "../components/Input";
import Options from "../components/Options";
import Dropdown from "../components/Dropdown";
import Minor from '../assets/Minor.png'
import Major from '../assets/Major.png'
import CheckMarkText from "../components/CheckMarkText";
import MyDropzone from "../components/MyDropzone";
import MyCalendar from "../components/Calendar";
import IconBlocks from "../components/IconBlocks";
import InHouse from '../assets/InHouse.png'
import CustomerService from '../assets/CustomerService.png'
import Visualised from '../assets/Visualised.png'
import RightArrow from '../assets/RightArrow.png'
import RightArrowGreen from '../assets/RightArrowGreen.png'
import Checkmark from '../assets/Checkmark.png'
import CheckmarkGreen from '../assets/CheckmarkGreen.png'
import PopupArrow from '../assets/PopupArrow.png'
import InHouseDrafting from '../assets/InHouseDrafting.png'
import CheckMarkSection from "../components/CheckMarkSection";
import { db } from "../firebase-config";
import { addDoc, collection, doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
// import jsPDF from 'jspdf'
import ModalComponent from '../components/Modal'

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

// Images


import SteplessExisting from '../assets/Examples/Stepless/Existing.png'
import SteplessProposed from '../assets/Examples/Stepless/Proposed.png'
import SteplessScope from '../assets/Examples/Stepless/Scope.png'
import SteplessWallElevation from '../assets/Examples/Stepless/WallElevation.png'
import SteplessInternal1 from '../assets/Examples/Stepless/Internal-1.png'
import SteplessInternal2 from '../assets/Examples/Stepless/Internal-2.png'
import SteplessInternal3 from '../assets/Examples/Stepless/Internal-3.png'
import SteplessInternal4 from '../assets/Examples/Stepless/Internal-4.png'
import SteplessInternal5 from '../assets/Examples/Stepless/Internal-5.png'
import SteplessInternal6 from '../assets/Examples/Stepless/Internal-6.png'
import SteplessInternal7 from '../assets/Examples/Stepless/Internal-7.png'

import SteplessExternal1 from '../assets/Examples/Stepless/External-1.png'
import SteplessExternal2 from '../assets/Examples/Stepless/External-2.png'
import SteplessSwitchboard1 from '../assets/Examples/Stepless/Switchboard-1.png'
import SteplessSwitchboard2 from '../assets/Examples/Stepless/Switchboard-2.png'

// Ramps

import RampsScope from '../assets/Examples/Ramps/RampScope.png'
import RampProposed from '../assets/Examples/Ramps/RampProposed.png'
import RampExisting from '../assets/Examples/Ramps/RampExisting.png'

import RampsProposed1 from '../assets/Examples/Ramps/RampProposed-1.png'
import RampsProposed2 from '../assets/Examples/Ramps/RampProposed-2.png'
import RampsDistance1 from '../assets/Examples/Ramps/RampDistance-1.png'
import RampsDistance2 from '../assets/Examples/Ramps/RampDistance-2.png'

// Steps

import StepsScope from '../assets/Examples/Steps/StepsScope.png'
import StepsProposed from '../assets/Examples/Steps/StepsProposed.png'
import StepsExisting from '../assets/Examples/Steps/StepsExisting.png'

import StepsProposed1 from '../assets/Examples/Steps/StepsProposed-1.png'
import StepsProposed2 from '../assets/Examples/Steps/StepsProposed-2.png'
import StepsDistance1 from '../assets/Examples/Steps/StepsDistance-1.png'
import StepsDistance2 from '../assets/Examples/Steps/StepsDistance-2.png'


// Barrister

import BarristerScope from '../assets/Examples/Barrister/BarristerScope.png'
import BarristerDistance1 from '../assets/Examples/Barrister/BarristerDistance-1.png'
import BarristerDistance2 from '../assets/Examples/Barrister/BarristerDistance-2.png'
import BarristerMarkedUp1 from '../assets/Examples/Barrister/BarristerMarkedUp-1.png'
import BarristerMarkedUp2 from '../assets/Examples/Barrister/BarristerMarkedUp-2.png'


// Concrete

import ConcreteScope from '../assets/Examples/Concrete/ConcreteScope.png'
import ConcreteProposed from '../assets/Examples/Concrete/ConcreteProposed.png'

import ConcreteProposed1 from '../assets/Examples/Concrete/ConcreteProposed-1.png'
import ConcreteProposed2 from '../assets/Examples/Concrete/ConcreteProposed-2.png'
import ConcreteDistance1 from '../assets/Examples/Concrete/ConcreteDistance-1.png'
import ConcreteDistance2 from '../assets/Examples/Concrete/ConcreteDistance-2.png'

// Internal Door


import InternalScope from '../assets/Examples/Internal/InternalScope.png'
// import InternalProposed from '../assets/Examples/Internal/InternalProposed.png'

import InternalProposed1 from '../assets/Examples/Internal/InternalProposed-1.png'
import InternalProposed2 from '../assets/Examples/Internal/InternalProposed-2.png'
import InternalDistance1 from '../assets/Examples/Internal/InternalDistance-1.png'
import InternalDistance2 from '../assets/Examples/Internal/InternalDistance-2.png'
import { usePlacesWidget } from "react-google-autocomplete";
import Checkbox from "../components/Checkbox";
import { fundingBodies } from "../constants";


// let pdfContent = []

const getUrlParams = () => {
    const url = window.location.href.split('?')[1]
    const urlParams = new URLSearchParams(url)
    const paramsObj = Object.fromEntries(urlParams)
    return paramsObj
}


const Dashboard = () => {

    const [loading, setLoading] = useState(false)
    const [showPopup, setShowPopup] = useState(false)
    const [showNotVicPopup, setShowNotVicPopup] = useState(false)
    const [modalContent, setModalContent] = useState([])
    const [modalTitle, setModalTitle] = useState('')

    const [page, setPage] = useState(0)
    const [pageSequence, setPageSequence] = useState(['Home', 'ModificationDetails'])

    const [showSummary, setShowSummary] = useState(false)
    const [showSection, setShowSection] = useState('')

    const [errors, setErrors] = useState([])
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [contactNo, setContactNo] = useState('')
    const [email, setEmail] = useState('')
    const [address, setAddress] = useState('')

    const [secondaryFirstName, setSecondaryFirstName] = useState('')
    const [secondaryLastName, setSecondaryLastName] = useState('')
    const [secondaryContactNo, setSecondaryContactNo] = useState('')
    const [secondaryEmail, setSecondaryEmail] = useState('')

    const [secondaryContact, setSecondaryContact] = useState('')
    const [fundingBody, setFundingBody] = useState('')

    const [homeCarePackageName, setHomeCarePackageName] = useState('')
    const [homeCarePackageNameOther, setHomeCarePackageNameOther] = useState('')

    const [requestorsPosition, setRequestorsPosition] = useState('')
    const [requestorPositionOther, setRequestorPositionOther] = useState('')

    const [isSameAsClient, setIsSameAsClient] = useState(false)

    const [requestorFirstName, setRequestorFirstName] = useState('')
    const [requestorLastName, setRequestorLastName] = useState('')
    const [requestorContactNo, setRequestorContactNo] = useState('')
    const [requestorEmail, setRequestorEmail] = useState('')

    const [modificationType, setModificationType] = useState('')

    // Minor Mods
    const [haveAllInfo, setHaveAllInfo] = useState('')
    const [minorPhotos, setMinorPhotos] = useState([])
    const [minorGeneralScope, setMinorGeneralScope] = useState('')
    const [dischargeClient, setDischargeClient] = useState('')
    const [dischargeDate, setDischargeDate] = useState('')

    // Major Mods
    const [modifications, setModifications] = useState([])

    // Stepless

    const [haveAllInfoStepLess, setHaveAllInfoStepLess] = useState('')

    const [steplessPropertyType, setSteplessPropertyType] = useState('')
    const [steplessFloorLevel, setSteplessFloorLevel] = useState('')

    const [steplessGeneralScope, setSteplessGeneralScope] = useState('')
    const [steplessGeneralScopeValue, setSteplessGeneralScopeValue] = useState('')
    const [steplessScopePhotos, setSteplessScopePhotos] = useState([])
    const [steplessProposedPhotos, setSteplessProposedPhotos] = useState([])
    const [steplessExistingPhotos, setSteplessExistingPhotos] = useState([])

    const [steplessInternalPhotos, setSteplessInternalPhotos] = useState([])
    const [steplessExternalPhotos, setSteplessExternalPhotos] = useState([])
    const [specificRequirementsStepless, setSpecificRequirementsStepless] = useState('')

    const [steplessJointVisit, setSteplessJointVisit] = useState('')
    const [steplessLocation, setSteplessLocation] = useState('')

    const [steplessDoorWideningRequired, setSteplessDoorWideningRequired] = useState('')
    const [steplessWallRemovalRequired, setSteplessWallRemovalRequired] = useState('')
    const [steplessNewSewerRequired, setSteplessNewSewerRequired] = useState('')
    const [steplessRelocationSewerRequired, setSteplessRelocationSewerRequired] = useState('')
    const [steplessNewBathRequired, setSteplessNewBathRequired] = useState('')
    const [steplessClientOwnHouse, setSteplessClientOwnHouse] = useState('')
    const [steplessLandlordApprovedModification, setSteplessLandlordApprovedModification] = useState('')

    // Ramps


    const [haveAllInfoRamps, setHaveAllInfoRamps] = useState('')
    const [rampsGeneralScope, setRampsGeneralScope] = useState('')
    const [rampsGeneralScopeValue, setRampsGeneralScopeValue] = useState('')
    const [rampsScopePhotos, setRampsScopePhotos] = useState([])
    const [rampsPropertyType, setRampsPropertyType] = useState('')
    // const [rampsFloorLevel, setRampsFloorLevel] = useState('')

    const [rampsProposedPhotosWithMeasurements, setRampsProposedPhotosWithMeasurements] = useState([])
    const [rampsProposedPhotos, setRampsProposedPhotos] = useState([])
    const [rampsExistingPhotos, setRampsExistingPhotos] = useState([])
    const [specificRequirementsRamps, setSpecificRequirementsRamps] = useState('')


    const [rampsJointVisit, setRampsJointVisit] = useState('')
    const [rampsLocation, setRampsLocation] = useState('')
    const [riseToDoorEntryRamps, setRiseToDoorEntryRamps] = useState('')
    const [rampGradient, setRampGradient] = useState('')
    const [rampsLandingTop, setRampsLandingTop] = useState('')
    const [rampsThreshold, setRampsThreshold] = useState('')
    const [rampsConcreteLandingRequired, setRampsConcreteLandingRequired] = useState('')
    const [rampsLongRequired, setRampsLongRequired] = useState('')
    const [rampsConcretePathRequired, setRampsConcretePathRequired] = useState('')
    const [rampsClientOwnHouse, setRampsClientOwnHouse] = useState('')


    // Major Steps
    const [stepsPropertyType, setStepsPropertyType] = useState('')

    const [haveAllInfoSteps, setHaveAllInfoSteps] = useState('')
    const [stepsGeneralScope, setStepsGeneralScope] = useState('')
    const [stepsGeneralScopeValue, setStepsGeneralScopeValue] = useState('')
    const [stepsScopePhotos, setStepsScopePhotos] = useState([])

    const [stepsProposedPhotosWithMeasurements, setStepsProposedPhotosWithMeasurements] = useState([])
    const [stepsProposedPhotos, setStepsProposedPhotos] = useState([])
    const [stepsExistingPhotos, setStepsExistingPhotos] = useState([])
    const [specificRequirementsSteps, setSpecificRequirementsSteps] = useState('')

    const [stepsJointVisit, setStepsJointVisit] = useState('')
    const [stepsLocation, setStepsLocation] = useState('')
    const [riseToDoorEntrySteps, setRiseToDoorEntrySteps] = useState('')
    const [riseOfSteps, setRiseOfSteps] = useState('')
    const [stepsType, setStepsType] = useState('')
    const [stepsLandingTop, setStepsLandingTop] = useState('')

    const [stepsThreshold, setStepsThreshold] = useState('')
    const [stepsConcreteLandingRequired, setStepsConcreteLandingRequired] = useState('')
    const [stepsLongRequired, setStepsLongRequired] = useState('')
    const [stepsConcretePathRequired, setStepsConcretePathRequired] = useState('')
    const [stepsClientOwnHouse, setStepsClientOwnHouse] = useState('')


    // Barister

    const [barristerPropertyType, setBarristerPropertyType] = useState('')

    const [barristerGeneralScope, setBarristerGeneralScope] = useState('')
    const [barristerGeneralScopeValue, setBarristerGeneralScopeValue] = useState('')
    const [barristerScopePhotos, setBarristerScopePhotos] = useState([])

    const [barristerProposedPhotosWithMeasurements, setBarristerProposedPhotosWithMeasurements] = useState([])
    const [barristerProposedPhotos, setBarristerProposedPhotos] = useState([])
    const [barristerExistingPhotos, setBarristerExistingPhotos] = useState([])
    const [specificRequirementsBarrister, setSpecificRequirementsBarrister] = useState('')

    // Concreting

    const [concretePropertyType, setConcretePropertyType] = useState('')
    // const [concreteFloorLevel, setConcreteFloorLevel] = useState('')

    const [haveAllInfoConcrete, setHaveAllInfoConcrete] = useState('')
    const [concreteGeneralScope, setConcreteGeneralScope] = useState('')
    const [concreteGeneralScopeValue, setConcreteGeneralScopeValue] = useState('')
    const [concreteScopePhotos, setConcreteScopePhotos] = useState([])

    const [concreteProposedPhotosWithMeasurements, setConcreteProposedPhotosWithMeasurements] = useState([])
    const [concreteProposedPhotos, setConcreteProposedPhotos] = useState([])
    const [concreteExistingPhotos, setConcreteExistingPhotos] = useState([])
    const [specificRequirementsConcrete, setSpecificRequirementsConcrete] = useState('')

    const [concreteJointVisit, setConcreteJointVisit] = useState('')
    const [concreteLocation, setConcreteLocation] = useState('')
    const [matchConcreteColor, setMatchConcreteColor] = useState('')
    const [removalPlantsConcrete, setRemovalPlantsConcrete] = useState('')
    const [stormWaterPitsRequired, setStormWaterPitsRequired] = useState('')
    const [paversNeedRelay, setPaversNeedRelay] = useState('')
    const [disposalOfTrees, setDisposalOfTrees] = useState('')

    const [concreteClientOwnHouse, setConcreteClientOwnHouse] = useState('')


    // Doorway

    const [doorwayPropertyType, setDoorwayPropertyType] = useState('')
    // const [doorwayFloorLevel, setDoorwayFloorLevel] = useState('')

    const [haveAllInfoDoorway, setHaveAllInfoDoorway] = useState('')
    const [doorwayGeneralScope, setDoorwayGeneralScope] = useState('')
    const [doorwayGeneralScopeValue, setDoorwayGeneralScopeValue] = useState('')
    const [doorwayScopePhotos, setDoorwayScopePhotos] = useState([])

    const [doorwayProposedPhotosWithMeasurements, setDoorwayProposedPhotosWithMeasurements] = useState([])
    const [doorwayProposedPhotos, setDoorwayProposedPhotos] = useState([])
    const [doorwayExistingPhotos, setDoorwayExistingPhotos] = useState([])
    const [specificRequirementsDoorway, setSpecificRequirementsDoorway] = useState('')

    const [doorwayJointVisit, setDoorwayJointVisit] = useState('')
    const [doorwayLocation, setDoorwayLocation] = useState('')
    const [infillDoorOpening, setInfillDoorOpening] = useState('')
    const [doorWidening, setDoorWidening] = useState('')
    const [createWallOpening, setCreateWallOpening] = useState('')
    const [doorType, setDoorType] = useState('')
    const [doorwayClientOwnHouse, setDoorwayClientOwnHouse] = useState('')


    const navigate = useNavigate()

    useEffect(() => {
        if (modificationType === 'Minor') {
            setPageSequence(['Home', 'ModificationDetails'])
        } else if (modificationType === 'Major') {
            if (modifications.length >= 0) {
                setPageSequence(['Home', 'ModificationDetails', ...modifications])
            }
        }
    }, [modificationType, modifications])

    useEffect(() => {

        setErrors([])

    }, [haveAllInfo, modificationType, haveAllInfoConcrete, haveAllInfoDoorway, haveAllInfoRamps, haveAllInfoStepLess, haveAllInfoSteps])


    useEffect(() => {

        const params = getUrlParams()
        if (params && params.id) {
            const id = params.id
            const mode = params.mode
            loadSummary(id, mode)
        }
        updateParentOnHeight()
    }, [])

    useEffect(() => {

        if (window.parent.postMessage) {
            window.parent.postMessage({
                scrollToTop: 'scrollToTop',
                id: 'quote-request-form'
            }, "*")
        }
    }, [page])

    useEffect(() => {
        const params = getUrlParams()
        // Updating when not on summary page - user is making edits.
        if (requestorsPosition === 'Private Client' && !params.id) {
            if (isSameAsClient) {
                setRequestorFirstName(firstName)
                setRequestorLastName(lastName)
                setRequestorContactNo(contactNo)
                setRequestorEmail(email)
            } else {
                setRequestorFirstName('')
                setRequestorLastName('')
                setRequestorContactNo('')
                setRequestorEmail('')
            }
        }
    }, [requestorsPosition, isSameAsClient])

    const updateParentOnHeight = async () => {
        setInterval(() => {
            if (window.parent.postMessage) {
                window.parent.postMessage({
                    height: document.body.scrollHeight,
                    id: 'quote-request-form'
                }, "*")
            }
        }, 500)
    }

    const loadSummary = async (id, mode) => {

        const data = await (await getDoc(doc(collection(db, 'quote-requests'), id))).data()
        setFirstName(data.firstName)
        setLastName(data.lastName)
        setContactNo(data.contactNo)
        setEmail(data.email)
        setAddress(data.address)
        setSecondaryFirstName(data.secondaryFirstName)
        setSecondaryLastName(data.secondaryLastName)
        setSecondaryContactNo(data.secondaryContactNo)
        setSecondaryEmail(data.secondaryEmail)
        setSecondaryContact(data.secondaryContact)
        setFundingBody(data.fundingBody)
        setHomeCarePackageName(data.homeCarePackageName)
        setHomeCarePackageNameOther(data.homeCarePackageNameOther)
        setRequestorsPosition(data.requestorsPosition)
        setRequestorPositionOther(data.requestorPositionOther)
        setRequestorFirstName(data.requestorFirstName)
        setRequestorLastName(data.requestorLastName)
        setRequestorContactNo(data.requestorContactNo)
        setRequestorEmail(data.requestorEmail)
        setModificationType(data.modificationType)
        setHaveAllInfo(data.haveAllInfo)
        setMinorPhotos(data.minorPhotos)
        setMinorGeneralScope(data.minorGeneralScope || '')
        setDischargeClient(data.dischargeClient)
        setDischargeDate(data.dischargeDate)
        setModifications(data.modifications)
        setHaveAllInfoStepLess(data.haveAllInfoStepLess)
        setSteplessPropertyType(data.steplessPropertyType)
        setSteplessFloorLevel(data.steplessFloorLevel)
        setSteplessGeneralScope(data.steplessGeneralScope)
        setSteplessGeneralScopeValue(data.steplessGeneralScopeValue)
        setSteplessScopePhotos(data.steplessScopePhotos)
        setSteplessProposedPhotos(data.steplessProposedPhotos)
        setSteplessExistingPhotos(data.steplessExistingPhotos)
        setSteplessInternalPhotos(data.steplessInternalPhotos)
        setSteplessExternalPhotos(data.steplessExternalPhotos)
        setSpecificRequirementsStepless(data.specificRequirementsStepless)
        setSteplessJointVisit(data.steplessJointVisit)
        setSteplessLocation(data.steplessLocation)
        setSteplessDoorWideningRequired(data.steplessDoorWideningRequired)
        setSteplessWallRemovalRequired(data.steplessWallRemovalRequired)
        setSteplessNewSewerRequired(data.steplessNewSewerRequired)
        setSteplessRelocationSewerRequired(data.steplessRelocationSewerRequired)
        setSteplessNewBathRequired(data.steplessNewBathRequired)
        setSteplessClientOwnHouse(data.steplessClientOwnHouse)
        setSteplessLandlordApprovedModification(data.steplessLandlordApprovedModification)
        setHaveAllInfoRamps(data.haveAllInfoRamps)
        setRampsGeneralScope(data.rampsGeneralScope)
        setRampsGeneralScopeValue(data.rampsGeneralScopeValue)
        setRampsScopePhotos(data.rampsScopePhotos)
        setRampsPropertyType(data.rampsPropertyType)
        // setRampsFloorLevel(data.rampsFloorLevel)
        setRampsProposedPhotosWithMeasurements(data.rampsProposedPhotosWithMeasurements)
        setRampsProposedPhotos(data.rampsProposedPhotos)
        setRampsExistingPhotos(data.rampsExistingPhotos)
        setSpecificRequirementsRamps(data.specificRequirementsRamps)
        setRampsJointVisit(data.rampsJointVisit)
        setRampsLocation(data.rampsLocation)
        setRiseToDoorEntryRamps(data.riseToDoorEntryRamps)
        setRampGradient(data.rampGradient)
        setRampsLandingTop(data.rampsLandingTop)
        setRampsThreshold(data.rampsThreshold)
        setRampsConcreteLandingRequired(data.rampsConcreteLandingRequired)
        setRampsLongRequired(data.rampsLongRequired)
        setRampsConcretePathRequired(data.rampsConcretePathRequired)
        setRampsClientOwnHouse(data.rampsClientOwnHouse)
        setStepsPropertyType(data.stepsPropertyType)
        setHaveAllInfoSteps(data.haveAllInfoSteps)
        setStepsGeneralScope(data.stepsGeneralScope)
        setStepsGeneralScopeValue(data.stepsGeneralScopeValue)
        setStepsScopePhotos(data.stepsScopePhotos)
        setStepsProposedPhotosWithMeasurements(data.stepsProposedPhotosWithMeasurements)
        setStepsProposedPhotos(data.stepsProposedPhotos)
        setStepsExistingPhotos(data.stepsExistingPhotos)
        setSpecificRequirementsSteps(data.specificRequirementsSteps)
        setStepsJointVisit(data.stepsJointVisit)
        setStepsLocation(data.stepsLocation)
        setRiseToDoorEntrySteps(data.riseToDoorEntrySteps)
        setRiseOfSteps(data.riseOfSteps)
        setStepsType(data.stepsType)
        setStepsLandingTop(data.stepsLandingTop)
        setStepsThreshold(data.stepsThreshold)
        setStepsConcreteLandingRequired(data.stepsConcreteLandingRequired)
        setStepsLongRequired(data.stepsLongRequired)
        setStepsConcretePathRequired(data.stepsConcretePathRequired)
        setStepsClientOwnHouse(data.stepsClientOwnHouse)
        setBarristerPropertyType(data.barristerPropertyType)
        setBarristerGeneralScope(data.barristerGeneralScope)
        setBarristerGeneralScopeValue(data.barristerGeneralScopeValue)
        setBarristerScopePhotos(data.barristerScopePhotos)
        setBarristerProposedPhotosWithMeasurements(data.barristerProposedPhotosWithMeasurements)
        setBarristerProposedPhotos(data.barristerProposedPhotos)
        setBarristerExistingPhotos(data.barristerExistingPhotos)
        setSpecificRequirementsBarrister(data.specificRequirementsBarrister)
        setConcretePropertyType(data.concretePropertyType)
        // setConcreteFloorLevel(data.concreteFloorLevel)
        setHaveAllInfoConcrete(data.haveAllInfoConcrete)
        setConcreteGeneralScope(data.concreteGeneralScope)
        setConcreteGeneralScopeValue(data.concreteGeneralScopeValue)
        setConcreteScopePhotos(data.concreteScopePhotos)
        setConcreteProposedPhotosWithMeasurements(data.concreteProposedPhotosWithMeasurements)
        setConcreteProposedPhotos(data.concreteProposedPhotos)
        setConcreteExistingPhotos(data.concreteExistingPhotos)
        setSpecificRequirementsConcrete(data.specificRequirementsConcrete)
        setConcreteJointVisit(data.concreteJointVisit)
        setConcreteLocation(data.concreteLocation)
        setMatchConcreteColor(data.matchConcreteColor)
        setRemovalPlantsConcrete(data.removalPlantsConcrete)
        setStormWaterPitsRequired(data.stormWaterPitsRequired)
        setPaversNeedRelay(data.paversNeedRelay)
        setDisposalOfTrees(data.disposalOfTrees)
        setConcreteClientOwnHouse(data.concreteClientOwnHouse)
        setDoorwayPropertyType(data.doorwayPropertyType)
        // setDoorwayFloorLevel(data.doorwayFloorLevel)
        setHaveAllInfoDoorway(data.haveAllInfoDoorway)
        setDoorwayGeneralScope(data.doorwayGeneralScope)
        setDoorwayGeneralScopeValue(data.doorwayGeneralScopeValue)
        setDoorwayScopePhotos(data.doorwayScopePhotos)
        setDoorwayProposedPhotosWithMeasurements(data.doorwayProposedPhotosWithMeasurements)
        setDoorwayProposedPhotos(data.doorwayProposedPhotos)
        setDoorwayExistingPhotos(data.doorwayExistingPhotos)
        setSpecificRequirementsDoorway(data.specificRequirementsDoorway)
        setDoorwayJointVisit(data.doorwayJointVisit)
        setDoorwayLocation(data.doorwayLocation)
        setInfillDoorOpening(data.infillDoorOpening)
        setDoorWidening(data.doorWidening)
        setCreateWallOpening(data.createWallOpening)
        setDoorType(data.doorType)
        setDoorwayClientOwnHouse(data.doorwayClientOwnHouse)
        setShowSection(mode)
        setShowSummary(true)
    }

    const firstPageValidations = [
        { label: 'firstName', value: firstName, message: 'First Name' },
        { label: 'lastName', value: lastName, message: 'Last Name' },
        { label: 'contactNo', value: contactNo, message: 'Contact No' },
        // { label: 'email', value: email, message: 'Email' },
        { label: 'address', value: address, message: 'Address' },

        { label: 'requestorFirstName', value: requestorFirstName, message: 'Requestor First Name' },
        { label: 'requestorLastName', value: requestorLastName, message: 'Requestor Last Name' },
        { label: 'requestorContactNo', value: requestorContactNo, message: 'Requestor Contact No' },
        { label: 'requestorEmail', value: requestorEmail, message: 'Requestor Email' },
    ]

    // Secondary Contact 
    const secondaryValidations = [
        { label: 'secondaryFirstName', value: secondaryFirstName, message: 'First Name of Secondary Contact' },
        { label: 'secondaryLastName', value: secondaryLastName, message: 'Last Name of Secondary Contact' },
        { label: 'secondaryContactNo', value: secondaryContactNo, message: 'Contact No of Secondary Contact' },
        { label: 'secondaryEmail', value: secondaryEmail, message: 'Email of Secondary Contact' },
    ]

    const steplessYesValidations = [
        { label: 'steplessPropertyType', value: steplessPropertyType, message: ' ' },
        { label: 'steplessFloorLevel', value: steplessFloorLevel, message: '' },
        { label: 'steplessGeneralScope', value: steplessGeneralScope, message: '' },
        { label: 'steplessProposedPhotos', isArray: true, value: steplessProposedPhotos, message: ' ' },
        { label: 'steplessExistingPhotos', isArray: true, value: steplessExistingPhotos, message: '' },
        { label: 'steplessInternalPhotos', isArray: true, value: steplessInternalPhotos, message: '' },
        { label: 'steplessExternalPhotos', isArray: true, value: steplessExternalPhotos, message: '' },
    ]

    const steplessNoValidations = [
        { label: 'steplessPropertyType', value: steplessPropertyType, message: ' ' },
        { label: 'steplessJointVisit', value: steplessJointVisit, message: '' },
        { label: 'steplessLocation', value: steplessLocation, message: '' },
        { label: 'steplessGeneralScope', value: steplessGeneralScope, message: '' },

        { label: 'steplessProposedPhotos', isArray: true, value: steplessProposedPhotos, message: ' ' },

        { label: 'steplessDoorWideningRequired', value: steplessDoorWideningRequired, message: '' },
        { label: 'steplessWallRemovalRequired', value: steplessWallRemovalRequired, message: '' },
        { label: 'steplessNewSewerRequired', value: steplessNewSewerRequired, message: '' },
        { label: 'steplessRelocationSewerRequired', value: steplessRelocationSewerRequired, message: '' },
        { label: 'steplessNewBathRequired', value: steplessNewBathRequired, message: '' },
        { label: 'steplessClientOwnHouse', value: steplessClientOwnHouse, message: '' },

    ]



    const rampsYesValidations = [
        { label: 'rampsPropertyType', value: rampsPropertyType, message: ' ' },
        // { label: 'rampsFloorLevel', value: rampsFloorLevel, message: '' },
        { label: 'rampsGeneralScope', value: rampsGeneralScope, message: '' },
        { label: 'rampsProposedPhotos', isArray: true, value: rampsProposedPhotos, message: ' ' },
        { label: 'rampsExistingPhotos', isArray: true, value: rampsExistingPhotos, message: '' },
        { label: 'rampsProposedPhotosWithMeasurements', isArray: true, value: rampsProposedPhotosWithMeasurements, message: ' ' },
    ]

    const rampsNoValidations = [
        { label: 'rampsPropertyType', value: rampsPropertyType, message: ' ' },
        { label: 'rampsJointVisit', value: rampsJointVisit, message: '' },
        { label: 'rampsLocation', value: rampsLocation, message: '' },
        { label: 'riseToDoorEntryRamps', value: riseToDoorEntryRamps, message: 'rise to door entry.' },
        { label: 'rampGradient', value: rampGradient, message: 'ramp gradient.' },
        { label: 'rampsLandingTop', value: rampsLandingTop, message: '' },
        { label: 'rampsThreshold', value: rampsThreshold, message: '' },
        { label: 'rampsConcreteLandingRequired', value: rampsConcreteLandingRequired, message: '' },
        { label: 'rampsConcretePathRequired', value: rampsConcretePathRequired, message: '' },
        { label: 'rampsLongRequired', value: rampsLongRequired, message: '' },
        { label: 'rampsGeneralScope', value: rampsGeneralScope, message: '' },

        { label: 'rampsProposedPhotos', isArray: true, value: rampsProposedPhotos, message: ' ' },

        { label: 'rampsClientOwnHouse', value: rampsClientOwnHouse, message: '' },

    ]




    const stepsYesValidations = [
        { label: 'stepsPropertyType', value: stepsPropertyType, message: ' ' },
        // { label: 'stepsFloorLevel', value: stepsFloorLevel, message: '' },
        { label: 'stepsGeneralScope', value: stepsGeneralScope, message: '' },
        { label: 'stepsProposedPhotos', isArray: true, value: stepsProposedPhotos, message: ' ' },
        { label: 'stepsExistingPhotos', isArray: true, value: stepsExistingPhotos, message: '' },
        { label: 'stepsProposedPhotosWithMeasurements', isArray: true, value: stepsProposedPhotosWithMeasurements, message: ' ' },
    ]

    const stepsNoValidations = [
        { label: 'stepsPropertyType', value: stepsPropertyType, message: ' ' },
        { label: 'stepsJointVisit', value: stepsJointVisit, message: '' },
        { label: 'stepsLocation', value: stepsLocation, message: '' },
        { label: 'riseToDoorEntrySteps', value: riseToDoorEntrySteps, message: 'rise to door entry.' },
        { label: 'riseOfSteps', value: riseOfSteps, message: 'rise to steps to achieve.' },
        { label: 'stepsType', value: stepsType, message: '' },
        { label: 'stepsLandingTop', value: stepsLandingTop, message: '' },
        { label: 'stepsThreshold', value: stepsThreshold, message: '' },
        { label: 'stepsConcreteLandingRequired', value: stepsConcreteLandingRequired, message: '' },
        { label: 'stepsConcretePathRequired', value: stepsConcretePathRequired, message: '' },
        { label: 'stepsLongRequired', value: stepsLongRequired, message: '' },
        { label: 'stepsGeneralScope', value: stepsGeneralScope, message: '' },

        { label: 'stepsProposedPhotos', isArray: true, value: stepsProposedPhotos, message: ' ' },

        { label: 'stepsClientOwnHouse', value: stepsClientOwnHouse, message: '' },

    ]



    const barristerValidations = [
        { label: 'barristerPropertyType', value: barristerPropertyType, message: ' ' },
        // { label: 'barristerFloorLevel', value: barristerFloorLevel, message: '' },
        { label: 'barristerGeneralScope', value: barristerGeneralScope, message: '' },
        { label: 'barristerProposedPhotos', isArray: true, value: barristerProposedPhotos, message: ' ' },
        { label: 'barristerExistingPhotos', isArray: true, value: barristerExistingPhotos, message: '' },
        { label: 'barristerProposedPhotosWithMeasurements', isArray: true, value: barristerProposedPhotosWithMeasurements, message: ' ' },
    ]

    const concreteYesValidations = [
        { label: 'concretePropertyType', value: concretePropertyType, message: ' ' },
        // { label: 'concreteFloorLevel', value: concreteFloorLevel, message: ' ' },
        { label: 'concreteGeneralScope', value: concreteGeneralScope, message: '' },
        { label: 'concreteProposedPhotos', isArray: true, value: concreteProposedPhotos, message: ' ' },
        { label: 'concreteExistingPhotos', isArray: true, value: concreteExistingPhotos, message: '' },
        { label: 'concreteProposedPhotosWithMeasurements', isArray: true, value: concreteProposedPhotosWithMeasurements, message: ' ' },
    ]

    const concreteNoValidations = [
        { label: 'concretePropertyType', value: concretePropertyType, message: ' ' },
        { label: 'concreteJointVisit', value: concreteJointVisit, message: '' },
        { label: 'concreteLocation', value: concreteLocation, message: '' },
        { label: 'matchConcreteColor', value: matchConcreteColor, message: '' },
        { label: 'removalPlantsConcrete', value: removalPlantsConcrete, message: '' },
        { label: 'stormWaterPitsRequired', value: stormWaterPitsRequired, message: '' },
        { label: 'paversNeedRelay', value: paversNeedRelay, message: '' },
        { label: 'disposalOfTrees', value: disposalOfTrees, message: '' },

        { label: 'concreteGeneralScope', value: concreteGeneralScope, message: '' },

        { label: 'concreteProposedPhotos', isArray: true, value: concreteProposedPhotos, message: ' ' },

        { label: 'concreteClientOwnHouse', value: concreteClientOwnHouse, message: '' },

    ]



    const doorwayYesValidations = [
        { label: 'doorwayPropertyType', value: doorwayPropertyType, message: ' ' },
        { label: 'doorwayGeneralScope', value: doorwayGeneralScope, message: '' },
        { label: 'doorwayProposedPhotos', isArray: true, value: doorwayProposedPhotos, message: ' ' },
        { label: 'doorwayExistingPhotos', isArray: true, value: doorwayExistingPhotos, message: '' },
        { label: 'doorwayProposedPhotosWithMeasurements', isArray: true, value: doorwayProposedPhotosWithMeasurements, message: ' ' },
    ]

    const doorwayNoValidations = [
        { label: 'doorwayPropertyType', value: doorwayPropertyType, message: ' ' },
        { label: 'doorwayJointVisit', value: doorwayJointVisit, message: '' },
        { label: 'doorwayLocation', value: doorwayLocation, message: '' },
        { label: 'infillDoorOpening', value: infillDoorOpening, message: '' },
        { label: 'doorWidening', value: doorWidening, message: '' },
        { label: 'createWallOpening', value: createWallOpening, message: '' },
        { label: 'doorType', value: doorType, message: '' },

        { label: 'doorwayGeneralScope', value: doorwayGeneralScope, message: '' },

        { label: 'doorwayProposedPhotos', isArray: true, value: doorwayProposedPhotos, message: ' ' },

        { label: 'doorwayClientOwnHouse', value: doorwayClientOwnHouse, message: '' },

    ]

    const performValidation = (validation, tempErrors) => {
        validation.forEach(element => {

            if (element.isArray) {
                if (element.value.length === 0) {
                    tempErrors.push({ name: element.label, message: 'Please enter ' + element.message })
                }
            } else if (!element.value) {
                tempErrors.push({ name: element.label, message: 'Please enter ' + element.message })
            }
        })
        return tempErrors
    }


    const handleNextPage = async () => {
        // Validate page / submit form.

        let tempErrors = []
        if (page === 0) {
            tempErrors = performValidation(firstPageValidations, tempErrors)

            if (!address.includes('VIC')) {
                setShowNotVicPopup(true)
                return
            }
            if (!/^[0-9+]+$/.test(contactNo)) {
                tempErrors.push({ name: 'contactNo', message: 'Contact number can only contain digits and +.' })
            }
            if (contactNo.length < 8) {
                tempErrors.push({ name: 'contactNo', message: 'Contact number should be atleast 8 digits.' })
            }
            if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(requestorEmail)) {
                tempErrors.push({ name: 'requestorEmail', message: 'Email doesn\'t match required format.' })

            }
            if (!secondaryContact) {
                tempErrors.push({ name: 'secondaryContact', message: 'Secondary Contact is Required.' })
            }

            if (secondaryContact === 'Yes') {
                tempErrors = performValidation(secondaryValidations, tempErrors)
                if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(secondaryEmail)) {
                    tempErrors.push({ name: 'secondaryEmail', message: 'Email doesn\'t match required format.' })

                }

                if (!/^[0-9+]+$/.test(secondaryContactNo)) {
                    tempErrors.push({ name: 'secondaryContactNo', message: 'Contact number can only contain digits and +.' })
                }

                if (secondaryContactNo.length < 8) {
                    tempErrors.push({ name: 'secondaryContactNo', message: 'Secondary Contact number should be atleast 8 digits.' })
                }
            }

            if (!fundingBody) {
                tempErrors.push({ name: 'fundingBody', message: 'Funding Body is Required.' })
            }

            if (fundingBody === 'Home Care Package' && !homeCarePackageName) {
                tempErrors.push({ name: 'homeCarePackageName', message: 'Home Care Package Name is Required.' })
            }

            if (fundingBody === 'Home Care Package' && homeCarePackageName && homeCarePackageName.value === 'Other' && !homeCarePackageNameOther) {
                tempErrors.push({ name: 'homeCarePackageNameOther', message: 'Home Care Package Name is Required.' })
            }

            if (!requestorsPosition) {
                tempErrors.push({ name: 'requestorsPosition', message: 'Requestors Position is Required.' })
            }


        } else if (page === 1) {
            if (!modificationType) {
                tempErrors.push({ name: 'modificationType', message: 'Modification Type is Required.' })
            }

            if (modificationType === 'Minor') {
                if (!haveAllInfo) {
                    tempErrors.push({ name: 'haveAllInfo', message: 'Have all required information is Required.' })
                }

                if (haveAllInfo === 'No') {

                } else if (haveAllInfo === 'Yes') {

                    if (minorPhotos.length === 0) {
                        tempErrors.push({ name: 'minorPhotos', message: 'Minor photos required.' })
                    }
                    if (!minorGeneralScope) {
                        tempErrors.push({ name: 'minorGeneralScope', message: 'Minor general scope is required.' })

                    }
                }


                if (!dischargeClient) {
                    tempErrors.push({ name: 'dischargeClient', message: 'Discharge information is Required.' })
                }

                if (dischargeClient === 'Yes' && !dischargeDate) {
                    tempErrors.push({ name: 'dischargeDate', message: 'Discharge information is Required.' })
                }
            } else {
                // Modification is major
                if (modifications.length === 0) {
                    tempErrors.push({ name: 'modifications', message: 'Pick at least one modification.' })
                }

            }
        } else if (pageSequence[page] === 'Stepless Shower') {

            if (!haveAllInfoStepLess) {
                tempErrors.push({ name: 'haveAllInfoStepLess', message: 'Pick one option.' })
            }

            if (haveAllInfoStepLess === 'Yes') {
                tempErrors = performValidation(steplessYesValidations, tempErrors)

            } else if (haveAllInfoStepLess === 'No') {

                tempErrors = performValidation(steplessNoValidations, tempErrors)

                if (steplessClientOwnHouse === 'Rented' && !steplessLandlordApprovedModification) {
                    tempErrors.push({ name: 'steplessLandlordApprovedModification', message: 'Pick one option.' })
                }
            }


            if (steplessGeneralScope === 'Upload File' && steplessScopePhotos.length === 0) {
                tempErrors.push({ name: 'steplessScopePhotos', message: 'Pick one option.' })
            } else if (steplessGeneralScope === 'Text Box in this Form' && !steplessGeneralScopeValue) {
                tempErrors.push({ name: 'steplessGeneralScopeValue', message: 'This value is required.' })
            }


        } else if (pageSequence[page] === 'Major Ramps') {
            if (!haveAllInfoRamps) {
                tempErrors.push({ name: 'haveAllInfoRamps', message: 'Pick one option.' })
            }


            if (haveAllInfoRamps === 'Yes') {
                tempErrors = performValidation(rampsYesValidations, tempErrors)

            } else if (haveAllInfoRamps === 'No') {

                tempErrors = performValidation(rampsNoValidations, tempErrors)
                // console.log('tempErrors', tempErrors)

                if (!/^[0-9]+$/.test(riseToDoorEntryRamps)) {
                    // tempErrors.push({ name: 'riseToDoorEntryRamps', message: 'Please enter only digits.' })
                }
                // if (rampsClientOwnHouse === 'Rented' && !rampsLandlordApprovedModification) {
                //     tempErrors.push({ name: 'steplessLandlordApprovedModification', message: 'Pick one option.' })
                // }
            }


            if (rampsGeneralScope === 'Upload File' && rampsScopePhotos.length === 0) {
                tempErrors.push({ name: 'rampsScopePhotos', message: 'Pick one option.' })
            } else if (rampsGeneralScope === 'Text Box in this Form' && !rampsGeneralScopeValue) {
                tempErrors.push({ name: 'rampsGeneralScopeValue', message: 'This value is required.' })
            }

        } else if (pageSequence[page] === 'Major Steps') {
            if (!haveAllInfoSteps) {
                tempErrors.push({ name: 'haveAllInfoSteps', message: 'Pick one option.' })
            }


            if (haveAllInfoSteps === 'Yes') {
                tempErrors = performValidation(stepsYesValidations, tempErrors)

            } else if (haveAllInfoSteps === 'No') {

                tempErrors = performValidation(stepsNoValidations, tempErrors)

                // if (stepsClientOwnHouse === 'Rented' && !stepsLandlordApprovedModification) {
                //     tempErrors.push({ name: 'steplessLandlordApprovedModification', message: 'Pick one option.' })
                // }
            }


            if (stepsGeneralScope === 'Upload File' && stepsScopePhotos.length === 0) {
                tempErrors.push({ name: 'stepsScopePhotos', message: 'Pick one option.' })
            } else if (stepsGeneralScope === 'Text Box in this Form' && !stepsGeneralScopeValue) {
                tempErrors.push({ name: 'stepsGeneralScopeValue', message: 'This value is required.' })
            }

        } else if (pageSequence[page] === 'Banister Make On-Site') {


            tempErrors = performValidation(barristerValidations, tempErrors)



            if (barristerGeneralScope === 'Upload File' && barristerScopePhotos.length === 0) {
                tempErrors.push({ name: 'barristerScopePhotos', message: 'Pick one option.' })
            } else if (barristerGeneralScope === 'Text Box in this Form' && !barristerGeneralScopeValue) {
                tempErrors.push({ name: 'barristerGeneralScopeValue', message: 'This value is required.' })
            }

        } else if (pageSequence[page] === 'Concreting') {

            if (!haveAllInfoConcrete) {
                tempErrors.push({ name: 'haveAllInfoConcrete', message: 'Pick one option.' })
            }


            if (haveAllInfoConcrete === 'Yes') {
                tempErrors = performValidation(concreteYesValidations, tempErrors)

            } else if (haveAllInfoConcrete === 'No') {

                tempErrors = performValidation(concreteNoValidations, tempErrors)

                // if (concreteClientOwnHouse === 'Rented' && !concreteLandlordApprovedModification) {
                //     tempErrors.push({ name: 'steplessLandlordApprovedModification', message: 'Pick one option.' })
                // }
            }


            if (concreteGeneralScope === 'Upload File' && concreteScopePhotos.length === 0) {
                tempErrors.push({ name: 'concreteScopePhotos', message: 'Pick one option.' })
            } else if (concreteGeneralScope === 'Text Box in this Form' && !concreteGeneralScopeValue) {
                tempErrors.push({ name: 'concreteGeneralScopeValue', message: 'This value is required.' })
            }
        } else if (pageSequence[page] === 'Internal Door Modification') {

            if (!haveAllInfoDoorway) {
                tempErrors.push({ name: 'haveAllInfoDoorway', message: 'Pick one option.' })
            }


            if (haveAllInfoDoorway === 'Yes') {
                tempErrors = performValidation(doorwayYesValidations, tempErrors)

            } else if (haveAllInfoDoorway === 'No') {

                tempErrors = performValidation(doorwayNoValidations, tempErrors)

                // if (doorwayClientOwnHouse === 'Rented' && !doorwayLandlordApprovedModification) {
                //     tempErrors.push({ name: 'steplessLandlordApprovedModification', message: 'Pick one option.' })
                // }
            }


            if (doorwayGeneralScope === 'Upload File' && doorwayScopePhotos.length === 0) {
                tempErrors.push({ name: 'doorwayScopePhotos', message: 'Pick one option.' })
            } else if (doorwayGeneralScope === 'Text Box in this Form' && !doorwayGeneralScopeValue) {
                tempErrors.push({ name: 'doorwayGeneralScopeValue', message: 'This value is required.' })
            }

        }

        setErrors(tempErrors)

        if (tempErrors.length > 0) {
            setTimeout(() => {
                document.getElementById('error-box').scrollIntoView({ behavior: 'smooth', block: 'center' })
            }, 300)
            return
        }

        setErrors([])


        if (page === pageSequence.length - 1) {

            // Save document and move to summary page
            // await db.collection('quote-requests').add({

            // })
            setLoading(true)

            const docInfo = await addDoc(collection(db, 'quote-requests'), {

                firstName,
                lastName,
                contactNo,
                email,

                address,

                secondaryFirstName,
                secondaryLastName,
                secondaryContactNo,
                secondaryEmail,

                secondaryContact,
                fundingBody,

                homeCarePackageName,
                homeCarePackageNameOther,

                requestorsPosition,
                requestorPositionOther,


                requestorFirstName,
                requestorLastName,
                requestorContactNo,
                requestorEmail,

                modificationType,

                // Minor Mods
                haveAllInfo,
                minorPhotos,
                minorGeneralScope,
                dischargeClient,
                dischargeDate,

                // Major Mods
                modifications,

                // Stepless

                haveAllInfoStepLess,

                steplessPropertyType,
                steplessFloorLevel,

                steplessGeneralScope,
                steplessGeneralScopeValue,
                steplessScopePhotos,
                steplessProposedPhotos,
                steplessExistingPhotos,

                steplessInternalPhotos,
                steplessExternalPhotos,
                specificRequirementsStepless,

                steplessJointVisit,
                steplessLocation,

                steplessDoorWideningRequired,
                steplessWallRemovalRequired,
                steplessNewSewerRequired,
                steplessRelocationSewerRequired,
                steplessNewBathRequired,
                steplessClientOwnHouse,
                steplessLandlordApprovedModification,

                // Ramps


                haveAllInfoRamps,
                rampsGeneralScope,
                rampsGeneralScopeValue,
                rampsScopePhotos,
                rampsPropertyType,
                // rampsFloorLevel,

                rampsProposedPhotosWithMeasurements,
                rampsProposedPhotos,
                rampsExistingPhotos,
                specificRequirementsRamps,


                rampsJointVisit,
                rampsLocation,
                riseToDoorEntryRamps,
                rampGradient,
                rampsLandingTop,
                rampsThreshold,
                rampsConcreteLandingRequired,
                rampsLongRequired,
                rampsConcretePathRequired,
                rampsClientOwnHouse,


                // Major Steps
                stepsPropertyType,

                haveAllInfoSteps,
                stepsGeneralScope,
                stepsGeneralScopeValue,
                stepsScopePhotos,

                stepsProposedPhotosWithMeasurements,
                stepsProposedPhotos,
                stepsExistingPhotos,
                specificRequirementsSteps,

                stepsJointVisit,
                stepsLocation,
                riseToDoorEntrySteps,
                riseOfSteps,
                stepsType,
                stepsLandingTop,

                stepsThreshold,
                stepsConcreteLandingRequired,
                stepsLongRequired,
                stepsConcretePathRequired,
                stepsClientOwnHouse,


                // Barister

                barristerPropertyType,

                barristerGeneralScope,
                barristerGeneralScopeValue,
                barristerScopePhotos,

                barristerProposedPhotosWithMeasurements,
                barristerProposedPhotos,
                barristerExistingPhotos,
                specificRequirementsBarrister,

                // Concreting

                concretePropertyType,
                // concreteFloorLevel,

                haveAllInfoConcrete,
                concreteGeneralScope,
                concreteGeneralScopeValue,
                concreteScopePhotos,

                concreteProposedPhotosWithMeasurements,
                concreteProposedPhotos,
                concreteExistingPhotos,
                specificRequirementsConcrete,

                concreteJointVisit,
                concreteLocation,
                matchConcreteColor,
                removalPlantsConcrete,
                stormWaterPitsRequired,
                paversNeedRelay,
                disposalOfTrees,

                concreteClientOwnHouse,


                // Doorway

                doorwayPropertyType,
                // doorwayFloorLevel,

                haveAllInfoDoorway,
                doorwayGeneralScope,
                doorwayGeneralScopeValue,
                doorwayScopePhotos,

                doorwayProposedPhotosWithMeasurements,
                doorwayProposedPhotos,
                doorwayExistingPhotos,
                specificRequirementsDoorway,

                doorwayJointVisit,
                doorwayLocation,
                infillDoorOpening,
                doorWidening,
                createWallOpening,
                doorType,
                doorwayClientOwnHouse
            })
            // window.alert()
            // console.log(docInfo.id)


            navigate('/thankYou')
            setLoading(false)


        } else {
            setPage(page + 1)
        }
    }

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        }
    };


    const { ref } = usePlacesWidget({
        apiKey: 'AIzaSyAAIj9X3P_LGfnQvAL9hNKqYA3W58rm7rk',
        onPlaceSelected: (place) => { setAddress(place.formatted_address) },
        options: {
            types: ["address"],
            componentRestrictions: { country: "au" },
        }
    })


    return (<div className="container">
        <div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label className="heading">Request a Quote</label>
                <label className="question" style={{ marginTop: '-5px' }}>All fields marked with an asterisk (*) are mandatory.</label>
            </div>

            <ModalComponent showModal={!!showNotVicPopup} setShowModal={setShowNotVicPopup}>
                <>
                    <h2 style={{ textAlign: 'center' }}>Address outside VIC!</h2>
                    <p style={{ color: 'red', marginTop: '-10px', textAlign: 'center' }}>Mobility Access Modifications does not currently service outside of Victoria.</p>
                    <button className="primary-button" style={{ margin: '10px auto' }} onClick={() => setShowNotVicPopup(false)}>Close</button>
                </>
            </ModalComponent>
            <ModalComponent showModal={!!showPopup} setShowModal={setShowPopup}>
                <> <h2 style={{ textAlign: 'center' }}>{modalTitle}</h2>
                    {/* <div style={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%', justifyContent: 'center', flexWrap: 'wrap', overflow: 'scroll' }}> */}

                    <Carousel
                        // swipeable={false}
                        // draggable={false}
                        showDots={true}
                        responsive={responsive}
                        infinite={true}
                        autoPlay={false}
                        deviceType={'desktop'}
                        containerClass="carousel-container"
                        itemClass="carousel-item"
                    >
                        {modalContent.map(r => <img src={r} key={r} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />)}
                    </Carousel>

                    {/* </div> */}
                    <button className="primary-button" style={{ margin: '10px auto' }} onClick={() => setShowPopup(false)}>Close</button>
                </>
            </ModalComponent>


            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {pageSequence.map((r, idx) => <div key={`step-${idx}`}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '39px', height: '39px', border: idx < page ? '1px solid green' : '1px solid #E6722A', backgroundColor: idx === page ? '#E6722A' : 'white', borderRadius: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {
                                idx >= page ?
                                    <label style={{ color: idx === page ? 'white' : '#E6722A', fontWeight: '500' }}>{idx + 1}</label>
                                    : <img src={CheckmarkGreen} style={{ width: '14px', height: '14px' }} />
                            }
                        </div>
                        {idx !== pageSequence.length - 1 && <img src={idx < page - 1 ? RightArrowGreen : RightArrow} style={{ width: '43px' }} />}
                    </div>
                </div>)}
            </div>
        </div>

        {errors.length > 0 && <div id='error-box' style={{ border: '1px solid #CF0000', borderRadius: '4px', padding: '10px 0', marginTop: '20px', background: '#FF000008' }}>
            <label style={{ marginLeft: '10px', color: '#CF0000' }}>Please fix all the highlighted sections.</label>
        </div>}

        {((showSummary && pageSequence.includes('Home')) || pageSequence[page] === 'Home') && <>

            <label className="sectionHeading">Client Details</label>
            <div className="row">
                <Input id="firstName" disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('firstName') && errors.find(({ name }) => name === 'firstName').message} errors={errors} name={'firstName'} value={firstName} setValue={setFirstName} label={'First Name*'} />
                <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('lastName') && errors.find(({ name }) => name === 'lastName').message} errors={errors} name={'lastName'} value={lastName} setValue={setLastName} label={'Last Name*'} />
            </div>

            <div className="row">
                <Input disabled={showSummary} type={'tel'} errorMessage={errors.map(({ name }) => name).includes('contactNo') && errors.find(({ name }) => name === 'contactNo').message} errors={errors} name={'contactNo'} value={contactNo} setValue={setContactNo} label={'Contact Number*'} />
                <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('email') && errors.find(({ name }) => name === 'email').message} errors={errors} name={'email'} value={email} setValue={setEmail} label={'Email'} />
            </div>

            <Input disabled={showSummary} refProp={ref} type={'text'} fullWidth errorMessage={errors.map(({ name }) => name).includes('address') && errors.find(({ name }) => name === 'address').message} errors={errors} name={'address'} value={address} setValue={setAddress} label={'Address*'} />

            <label className="question">Does the client have a secondary contact? *</label>
            <Options disabled={showSummary} options={['Yes', 'No']} error={errors.map(({ name }) => name).includes('secondaryContact')} chosenOption={secondaryContact} setChosenOption={setSecondaryContact} />
            {secondaryContact === 'Yes' && <>
                <div className="row">
                    <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('secondaryFirstName') && errors.find(({ name }) => name === 'secondaryFirstName').message} errors={errors} name={'secondaryFirstName'} value={secondaryFirstName} setValue={setSecondaryFirstName} label={'First Name*'} />
                    <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('secondaryLastName') && errors.find(({ name }) => name === 'secondaryLastName').message} errors={errors} name={'secondaryLastName'} value={secondaryLastName} setValue={setSecondaryLastName} label={'Last Name*'} />
                </div>

                <div className="row">
                    <Input disabled={showSummary} type={'tel'} errorMessage={errors.map(({ name }) => name).includes('secondaryContactNo') && errors.find(({ name }) => name === 'secondaryContactNo').message} errors={errors} name={'secondaryContactNo'} value={secondaryContactNo} setValue={setSecondaryContactNo} label={'Contact Number*'} />
                    <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('secondaryEmail') && errors.find(({ name }) => name === 'secondaryEmail').message} errors={errors} name={'secondaryEmail'} value={secondaryEmail} setValue={setSecondaryEmail} label={'Email*'} />
                </div>
            </>}

            <label className="sectionHeading" style={{ marginTop: '60px' }}>Who is funding the modification?</label>
            <label className="question" style={{ marginTop: '20px' }}>Funding Body *</label>
            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('fundingBody')} options={['NDIS', 'DVA', 'Private Client', 'SWEP', 'TAC', 'Work Cover', 'Home Care Package']} chosenOption={fundingBody} setChosenOption={setFundingBody} />

            {fundingBody === 'Home Care Package' && <div className="row">
                <Dropdown disabled={showSummary} options={[...fundingBodies, 'Other']} value={homeCarePackageName} setValue={setHomeCarePackageName} label={'Name of Home Care Package *'} errorFields={errors} name={'homeCarePackageName'} />
                {homeCarePackageName && homeCarePackageName.value === 'Other' && <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('homeCarePackageNameOther') && errors.find(({ name }) => name === 'homeCarePackageNameOther').message} errors={errors} name={'homeCarePackageNameOther'} value={homeCarePackageNameOther} setValue={setHomeCarePackageNameOther} label={'Name of Home Care Package (other) *'} />}
            </div>
            }

            <label className="sectionHeading" style={{ marginTop: '60px' }}>Requester’s Details</label>
            <label className="question" style={{ marginTop: '20px' }}>Requester’s position*</label>


            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('requestorsPosition')} options={['Occupational Therapist', 'Architect', 'Case Manager', 'Private Client', 'Other']} chosenOption={requestorsPosition} setChosenOption={setRequestorsPosition} />

            {requestorsPosition === 'Private Client' && <Checkbox label={'Is same as client?'} name='sameAsClient' value={isSameAsClient} setValue={setIsSameAsClient} />}

            <div className="row">
                {requestorsPosition === 'Other' && <Input disabled={showSummary} type={'text'} fullWidth errorMessage={errors.map(({ name }) => name).includes('requestorPositionOther') && errors.find(({ name }) => name === 'requestorPositionOther').message} errors={errors} name={'requestorPositionOther'} value={requestorPositionOther} setValue={setRequestorPositionOther} label={'Requestor\'s position (other)'} />}

                <div className="row">
                    <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('requestorFirstName') && errors.find(({ name }) => name === 'requestorFirstName').message} errors={errors} name={'requestorFirstName'} value={requestorFirstName} setValue={setRequestorFirstName} label={'First Name*'} />
                    <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('requestorLastName') && errors.find(({ name }) => name === 'requestorLastName').message} errors={errors} name={'requestorLastName'} value={requestorLastName} setValue={setRequestorLastName} label={'Last Name*'} />
                </div>

                <div className="row">
                    <Input disabled={showSummary} type={'tel'} errorMessage={errors.map(({ name }) => name).includes('requestorContactNo') && errors.find(({ name }) => name === 'requestorContactNo').message} errors={errors} name={'requestorContactNo'} value={requestorContactNo} setValue={setRequestorContactNo} label={'Contact Number*'} />
                    <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('requestorEmail') && errors.find(({ name }) => name === 'requestorEmail').message} errors={errors} name={'requestorEmail'} value={requestorEmail} setValue={setRequestorEmail} label={'Email*'} />
                </div>


            </div>

        </>}

        {
            ((showSummary && pageSequence.includes('ModificationDetails')) || pageSequence[page] === 'ModificationDetails') && <>
                <label className="sectionHeading">Modification Details</label>
                <label className="question">What is the modification type? *</label>
                <Options disabled={showSummary} options={['Minor', 'Major']} error={errors.map(({ name }) => name).includes('modificationType')} chosenOption={modificationType} setChosenOption={setModificationType} />
                <div className="explainer-box">
                    <label className="question" style={{ color: '#3F3F3F', textAlign: 'center', fontWeight: '500' }}>What is the difference between a minor and major modification?</label>
                    <div className="explainer-box-container">
                        <div className="explainer-box-columns">
                            <img src={Minor} style={{ width: '200px' }} />
                            <label className="question" style={{ color: '#3F3F3F', fontWeight: '500' }}>Minor Home Modifications</label>
                            <label className="explainer-box-text"> <a href="https://mobilityaccess.com.au/service/minor-
modifications/what-are-minor-modifications/" target="_blank">Minor home modifications</a> are small-scale installations of standard or custom manufactured products, designed to enhance the functionality, accessibility and safety of your clients home. </label>
                            <label className="explainer-box-text">Installations that take 1-3 hours </label>
                            <div style={{ display: 'flex' }}>
                                <div>
                                    <CheckMarkText label={'Grab Rails/Modular Rails/Towel Combo Rails'} />
                                    <CheckMarkText label={'Banister Rails'} />
                                    <CheckMarkText label={'Ramps (up to 189 mm rise)'} />
                                    <CheckMarkText label={'Lever Taps'} />
                                    <CheckMarkText label={'Door Magnets'} />
                                    <CheckMarkText label={'Stove Timers'} />
                                    <CheckMarkText label={'Safety Hinges'} />
                                </div>

                                <div>
                                    <CheckMarkText label={'Handheld Shower Hose'} />
                                    <CheckMarkText label={'Removal of Shower Screen, Add Rod & Curtain'} />
                                    <CheckMarkText label={'Platform Steps (up to 189 mm rise)'} />
                                    <CheckMarkText label={'Shower Base Inserts'} />
                                    <CheckMarkText label={'Non-slip floor treatment'} />
                                    <CheckMarkText label={'White Vision Strips'} />
                                </div>
                            </div>
                        </div>
                        <div className="explainer-box-columns">

                            <img src={Major} style={{ width: '340px' }} />
                            <label className="question" style={{ color: '#3F3F3F', fontWeight: '500' }}>Major Home Modifications</label>
                            <label className="explainer-box-text"> <a href="https://mobilityaccess.com.au/service/major-
modifications/what-are-major-modifications/" target="_blank">Major home modifications</a> are large-scale builds that are custom made on-site, designed for long-term permanent solutions to enhance disability access and promote independent living. </label>
                            <label className="explainer-box-text">Installations that take 1 - 30 days</label>

                            <div style={{ display: 'flex' }}>
                                <div>
                                    <CheckMarkText label={'Stepless Shower'} />
                                    <CheckMarkText label={'Major Ramps'} />
                                    <CheckMarkText label={'Major Steps'} />
                                    <CheckMarkText label={'Major Platform Steps'} />

                                </div>

                                <div>
                                    <CheckMarkText label={'Banister Make On-Site'} />
                                    <CheckMarkText label={'Concreting'} />
                                    <CheckMarkText label={'Internal Door Modification'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {modificationType === 'Minor' ? <>

                    <label className="sectionHeading">Minor Request Details</label>
                    <label className="question">Do you have all the required information and photos for the request? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('haveAllInfo')} options={['Yes', 'No']} chosenOption={haveAllInfo} toggle setChosenOption={setHaveAllInfo} />

                    {!haveAllInfo && <div className="explainer-box">
                        <label className="question" style={{ color: '#3F3F3F', textAlign: 'center', fontWeight: '500' }}>Quote application requirements for minor modifications.</label>

                        <div className="explainer-box-container">
                            <div className="explainer-box-columns">

                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '25px', width: '26px', height: '26px', backgroundColor: '#E6722A', borderRadius: '15px' }}>
                                        <label style={{ fontWeight: '600', color: 'white', textAlign: 'center' }}>1</label>
                                    </div>
                                    <label className="question" style={{ color: '#3F3F3F', fontWeight: '500' }}>General scope of work</label>
                                </div>

                                <div style={{ marginLeft: '40px' }}>
                                    <label className="explainer-box-text">OT Specs, builder’s brief or clear outline of works required. </label>
                                </div>


                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '25px', width: '26px', height: '26px', backgroundColor: '#E6722A', borderRadius: '15px' }}>
                                        <label style={{ fontWeight: '600', color: 'white', textAlign: 'center' }}>2</label>
                                    </div>
                                    <label className="question" style={{ color: '#3F3F3F', fontWeight: '500' }}>Photos of request</label>
                                </div>
                                {/* <label className="explainer-box-text">OT Specs, builder’s brief or clear outline of works required. </label> */}
                                <div style={{ marginLeft: '40px' }}>
                                    <CheckMarkText label={'General Scope of Work Description, OT Specs, Builder\'s Brief or Clear Outline of Works Required (a sentence or two).'} />
                                    <CheckMarkText label={'Photos with markup of proposed modifications, measurements and location.'} />
                                    <CheckMarkText label={'For shower access modifications, provide a floor plan of the bathroom.'} />
                                    <CheckMarkText label={'For ramps, steps or banister rails requests, provide a photo of the entire area from 5 meters away for us to assess the turning circle and path of travel.'} />
                                </div>

                            </div>
                            <div className="explainer-box-columns">


                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '25px', width: '26px', height: '26px', backgroundColor: '#E6722A', borderRadius: '15px' }}>
                                        <label style={{ fontWeight: '600', color: 'white', textAlign: 'center' }}>3</label>
                                    </div>
                                    <label className="question" style={{ color: '#3F3F3F', fontWeight: '500' }}>Specifications for fixtures and products</label>
                                </div>
                                <div style={{ marginLeft: '40px' }}>
                                    <label className="explainer-box-text">Specify material, finish, colour, powder-coating, painted rails and any other product specifications. </label>
                                </div>
                                <div style={{ marginTop: '50px' }}><img src={PopupArrow} style={{ marginBottom: '-4px', width: '24px', height: '24px', marginRight: '4px' }} /> <span style={{ color: '#E6722A', }} className="hover" onClick={() => window.open(`https://mobilityaccess.com.au/wp-content/uploads/2024/09/MAM-Minor-Mods-Example-Quote-Requests.pdf`)}>View examples </span> <span style={{ color: '#7B7B7B' }}> of common minor modification quote requests.</span></div>
                            </div>
                        </div>
                    </div>}

                    {haveAllInfo === 'Yes' ? <>
                        <label className="question">Upload scope of work with detailed measurements and marked-up photos *</label>
                        <label className="hint"> <span className="hover" style={{ color: '#E6722A' }} onClick={() => { window.open('https://mobilityaccess.com.au/wp-content/uploads/2024/09/MAM-Minor-Mods-Example-Quote-Requests.pdf', '_blank') }}>View an example</span> of a with detailed measurements and marked-up photos.</label>
                        <CheckMarkText label={'Photos with markup of proposed modifications, measurements and location.'} />
                        <CheckMarkText label={'Photos of the entire area from a distance to look for potential issues with space restrictions and to check for safety compliance.'} />
                        <CheckMarkText label={'For ramps, steps or banister rails requests, provide a photo of the entire area from 5 meters away for us to assess the turning circle and path of travel.'} />


                        <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'minorPhotos'} images={minorPhotos} updateImage={(doc) => setMinorPhotos(doc)} />

                        <label className="question" style={{ marginTop: '10px', marginBottom: '-5px' }}>Scope of Works Description</label>
                        {showSummary ?
                            <p style={{ whiteSpace: 'break-spaces' }}>{minorGeneralScope}</p>
                            :
                            <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('minorGeneralScope') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={minorGeneralScope} onChange={(e) => setMinorGeneralScope(e.target.value)}></textarea>}
                    </> : haveAllInfo === 'No' && <>
                        <IconBlocks title={'Request a call with our Customer Service team.'} icon={CustomerService}>
                            <>
                                <label style={{ color: '#5E5E5E' }}>Our professional trade experts will visit your clients home to gather all necessary information. Once you've submitted your quote request, we'll reach out to schedule a convenient time for our team to measure the area for the modification.</label>
                                <label style={{ marginTop: '20px', color: '#5E5E5E' }}>Speak with our Customer Service Officer who can direct you to our specialised Estimating team who can you to meet your quote requirements.</label>
                            </>
                        </IconBlocks>
                        <IconBlocks title={'Experience Our Exceptional In-House Measuring Service.'} icon={InHouse}>
                            <>
                                <label style={{ color: '#5E5E5E' }}>Our professional trade experts will visit your clients home to gather all necessary information. Once you've submitted your quote request, we'll reach out to schedule a convenient time for our team to measure the area for the modification.
                                </label>
                                <label style={{ marginTop: '20px', color: '#5E5E5E' }}>    This service does have a fee that will be included in your quote.</label>
                            </>
                        </IconBlocks>
                    </>}

                    <label className="question">Is your client being discharged from hospital? *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('dischargeClient')} options={['Yes', 'No']} chosenOption={dischargeClient} setChosenOption={setDischargeClient} />

                    {dischargeClient === 'Yes' && <>
                        <label className="question">What date is the discharge?*</label>
                        <MyCalendar disabled={showSummary} error={errors.map(({ name }) => name).includes('dischargeDate')} startDate={dischargeDate} setStartDate={setDischargeDate} />
                    </>}

                    <IconBlocks title={'Has Your Client Visualised The Modification Yet?'} icon={Visualised}>
                        <label style={{ color: '#5E5E5E' }}>We recommend allowing clients to preview modifications before installation.
                        </label>
                        <label style={{ marginTop: '20px', color: '#5E5E5E' }}>
                            Our <span style={{ color: '#E6722A', fontWeight: '500' }} className="hover" onClick={() => { window.open('https://mobilityaccess.com.au/gallery/', '_blank') }}> website gallery</span> showcases many of our minor modifications. Upon request, we can promptly email our brochure to your client. This step is essential to ensure every MAM job exceeds expectations and brings the highest client satisfaction.</label>
                    </IconBlocks>

                </> : modificationType === 'Major' && <>
                    <label className="sectionHeading">What is the modification?</label>
                    <label className="question">You can select more than one option</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('modifications')} multi options={['Stepless Shower', 'Major Ramps', 'Major Steps', 'Banister Make On-Site', 'Concreting', 'Internal Door Modification']} chosenOption={modifications} setChosenOption={setModifications} />
                </>}
            </>
        }

        {
            ((showSummary && (!showSection || (showSection && showSection === 'Stepless Shower')) && pageSequence.includes('Stepless Shower')) || pageSequence[page] === 'Stepless Shower') && <>
                <label className="sectionHeading">Stepless Shower Modification Details</label>
                <label className="question">Do you have all the required information and photos for the quote?</label>

                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('haveAllInfoStepLess')} options={['Yes', 'No']} chosenOption={haveAllInfoStepLess} toggle setChosenOption={setHaveAllInfoStepLess} />



                {!haveAllInfoStepLess && <div className="explainer-box">
                    <label className="question" style={{ color: '#3F3F3F', textAlign: 'center', fontWeight: '500' }}>Quote Application Requirements for Stepless Shower Modifications</label>

                    <div className="explainer-box-container">
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'Floor Plans'} label={'Existing plan & proposed plan with detailed measurements.'} />
                            <CheckMarkSection title={'Wall Elevations (optional)'} label={'For complex, custom & non-Standard modifications only.'} />
                            <CheckMarkSection title={'Floor Structure'} label={'Timber, concrete or suspended slab.'} />
                            <CheckMarkSection title={'Wall Structure'} label={'Brick veneer, weatherboard, double brick or concrete.'} />
                            <CheckMarkSection title={'General Scope of Work'} label={'List down the scope of work in detail.'} />

                        </div>
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'Specifications for Non-standard Fixtures / Products'} label={'If opting not to use standard MAM fixtures/products, list the product name, product code, prime cost and web link.'} />
                            <CheckMarkSection title={'Existing Photos'} label={'Photos of proposed area to include and cover the below:'} />

                            {['Internal Photos: All walls, ceiling, entire area from a distance, area in front of bathroom.', 'External Photos: Sewer point, plumbing lines & sewer stack, area outside bathroom wall.', '2x Photos of Electrical Switchboard: (1) close up & (2) from 2 meters away.'].map((title) => <div key={title} style={{ display: 'flex', marginTop: '10px', alignItems: 'center' }}> <img src={Checkmark} style={{ width: '15px', height: '12px', marginRight: '4px', marginTop: '4px' }} />
                                <label style={{ color: '#5E5E5E', fontSize: '16px', fontWeight: '400' }}><span style={{ fontWeight: '500' }}>{title.split(':')[0]}:</span> {title.split(':')[1]}</label>
                            </div>)}

                            <div style={{ marginTop: '50px' }}><img src={PopupArrow} style={{ marginBottom: '-4px', width: '24px', height: '24px', marginRight: '4px' }} /> <span style={{ color: '#E6722A', }} className="hover" onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2024/09/QR_Bathroom_V1.pdf')}>View example </span> <span style={{ color: '#7B7B7B' }}> of a stepless shower modification quote request.</span></div>
                        </div>
                    </div>
                </div>}

                {haveAllInfoStepLess === 'Yes' && <>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={steplessPropertyType} setChosenOption={setSteplessPropertyType} />

                    <label className="question">Floor Level *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessFloorLevel')} options={['Ground Floor', 'Other']} chosenOption={steplessFloorLevel} setChosenOption={setSteplessFloorLevel} />

                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([SteplessScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={steplessGeneralScope} setChosenOption={setSteplessGeneralScope} />

                    {!steplessGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        steplessGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'steplessScopePhotos'} images={steplessScopePhotos} updateImage={(doc) => setSteplessScopePhotos(doc)} />
                            : steplessGeneralScope === 'Text Box in this Form' &&

                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{steplessGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('steplessGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={steplessGeneralScopeValue} onChange={(e) => setSteplessGeneralScopeValue(e.target.value)}></textarea>)

                    }

                    <div className="row">
                        <div className="row-block">
                            <label className="question">Upload proposed plan with details and measurements * </label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of a <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([SteplessProposed]); setModalTitle('Proposed Plan') }}>proposed plan</span> or<span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([SteplessWallElevation]); setModalTitle('Wall Elevation') }}> wall elevations.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'steplessProposedPhotos'} images={steplessProposedPhotos} updateImage={(doc) => setSteplessProposedPhotos(doc)} />

                        </div>
                        <div className="row-block">
                            <label className="question">Upload existing plan with details and measurements *  </label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of an existing<span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([SteplessExisting]); setModalTitle('Existing Plan') }}> bathroom plan.</span></label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'steplessExistingPhotos'} images={steplessExistingPhotos} updateImage={(doc) => setSteplessExistingPhotos(doc)} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="row-block">
                            <label className="question">Upload internal photos of the bathroom *</label>
                            <label style={{ color: '#7B7B7B', marginTop: '-5px' }}>View examples of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([SteplessInternal1, SteplessInternal2, SteplessInternal3, SteplessInternal4, SteplessInternal5, SteplessInternal6]); setModalTitle('Internal Bathroom Photos') }}>internal bathroom photos.</span>  </label>
                            <label style={{ color: '#7B7B7B', marginBottom: '40px', marginTop: '5px' }}>All walls, ceiling and area in front of bathroom door.</label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'steplessInternalPhotos'} images={steplessInternalPhotos} updateImage={(doc) => setSteplessInternalPhotos(doc)} />

                        </div>
                        <div className="row-block">
                            <label className="question">Upload required external photos *</label>
                            <label style={{ color: '#7B7B7B', marginTop: '-5px' }}>View an example of an required<span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([SteplessExternal1, SteplessExternal2, SteplessSwitchboard1, SteplessSwitchboard2]); setModalTitle('External Photos') }}> external photos.</span></label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '5px' }}>Sewer point, plumbing lines & sewer stack, area outside bathroom wall. 2x Photos of Electrical Switchboard: (1) close up & (2) from 2 meters away. </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'steplessExternalPhotos'} images={steplessExternalPhotos} updateImage={(doc) => setSteplessExternalPhotos(doc)} />
                        </div>
                    </div>

                    <label className="question">Any specific requirements?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsStepless} onChange={(e) => setSpecificRequirementsStepless(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>
                </>}


                {haveAllInfoStepLess === 'No' && <>

                    <IconBlocks icon={InHouseDrafting} title={'Discover Our Premier In-House Drafting Service.'}>
                        <label style={{ color: '#5E5E5E' }}>Our expert draftsperson will visit your site, gather all necessary information, and propose tailored solutions that meet your clients' needs, site conditions, and construction materials. Want to find out more? Check our  <span className="hover" style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/service/major-modifications/draftsperson-service/', '_blank')}> draftsperson page</span> on our website or view our <span className='hover' style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2022/09/Schedule-of-Rates-DRAFTSPERSON-Ver-4-26-March-2024.pdf', '_blank')}>draftsperson's schedule of rates.</span>
                        </label>

                        <label style={{ marginTop: '20px', color: '#5E5E5E' }}>Simply fill out the pre-appointment information below, and we will send a quote for the draftsperson's service. It’s that easy!</label>


                    </IconBlocks>

                    <label className="sectionHeading">Draftsperson pre-appointment information</label>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={steplessPropertyType} setChosenOption={setSteplessPropertyType} />

                    <label className="question">Do you require a joint Visit with OT/Client? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessJointVisit')} options={['Joint visit with OT', 'Joint visit with client only', 'Joint visit with family members']} chosenOption={steplessJointVisit} setChosenOption={setSteplessJointVisit} />

                    <label className="question">Location *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessLocation')} options={['Ground Floor', 'Other']} chosenOption={steplessLocation} setChosenOption={setSteplessLocation} />

                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([SteplessScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={steplessGeneralScope} setChosenOption={setSteplessGeneralScope} />

                    {!steplessGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        steplessGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'steplessScopePhotos'} images={steplessScopePhotos} updateImage={(doc) => setSteplessScopePhotos(doc)} />
                            : steplessGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{steplessGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('steplessGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={steplessGeneralScopeValue} onChange={(e) => setSteplessGeneralScopeValue(e.target.value)}></textarea>)

                    }


                    <label className="question">Upload photos of the proposed work area * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View examples of required <span style={{ color: '#E6722A' }} onClick={() => { setShowPopup(true); setModalContent([SteplessExternal1, SteplessExternal2, SteplessInternal1, SteplessInternal2, SteplessInternal3, SteplessInternal4, SteplessInternal5, SteplessInternal6, SteplessInternal7, SteplessSwitchboard1, SteplessSwitchboard2]); setModalTitle('Photos') }}>photos.</span>  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'steplessProposedPhotos'} images={steplessProposedPhotos} updateImage={(doc) => setSteplessProposedPhotos(doc)} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Door widening required ? * </label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessDoorWideningRequired')} options={['Yes', 'No']} chosenOption={steplessDoorWideningRequired} setChosenOption={setSteplessDoorWideningRequired} />
                            <label className="question">New sewer point required? * </label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessNewSewerRequired')} options={['Yes', 'No']} chosenOption={steplessNewSewerRequired} setChosenOption={setSteplessNewSewerRequired} />

                            <label className="question">Will there be a new bath? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessNewBathRequired')} options={['Yes', 'No']} chosenOption={steplessNewBathRequired} setChosenOption={setSteplessNewBathRequired} />
                            {steplessClientOwnHouse === 'Rented' && <><label className="question">Has the landlord approved installation of this modification?*</label>
                                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessLandlordApprovedModification')} options={['Yes', 'No']} chosenOption={steplessLandlordApprovedModification} setChosenOption={setSteplessLandlordApprovedModification} /></>}

                        </div>
                        <div className="row-block">
                            <label className="question">Wall removal required? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessWallRemovalRequired')} options={['Yes', 'No']} chosenOption={steplessWallRemovalRequired} setChosenOption={setSteplessWallRemovalRequired} />
                            <label className="question">Relocation of sewer point? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessRelocationSewerRequired')} options={['Yes', 'No']} chosenOption={steplessRelocationSewerRequired} setChosenOption={setSteplessRelocationSewerRequired} />
                            <label className="question">Does the client own the house? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('steplessClientOwnHouse')} options={['Owned', 'Rented']} chosenOption={steplessClientOwnHouse} setChosenOption={setSteplessClientOwnHouse} />

                        </div>
                    </div>

                    <label className="question">Any additional Comments?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsStepless} onChange={(e) => setSpecificRequirementsStepless(e.target.value)}></textarea>


                </>}


            </>
        }




        {
            ((showSummary && (!showSection || (showSection && showSection === 'Major Ramps')) && pageSequence.includes('Major Ramps')) || pageSequence[page] === 'Major Ramps') && <>
                <label className="sectionHeading">Major Ramps Modification Details</label>
                <label className="question">Do you have all the required information and photos for the quote?</label>

                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('haveAllInfoRamps')} options={['Yes', 'No']} chosenOption={haveAllInfoRamps} toggle setChosenOption={setHaveAllInfoRamps} />



                {!haveAllInfoRamps && <div className="explainer-box">
                    <label className="question" style={{ color: '#3F3F3F', textAlign: 'center', fontWeight: '500' }}>Quote Application Requirements for Major Ramps Modifications</label>

                    <div className="explainer-box-container">
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'Plans'} label={'Existing plan & proposed plan with detailed measurements.'} />
                            <CheckMarkSection title={'Existing Photos'} label={'Existing photos of the proposed area including a photo of the entire area from a distance to look for potential issues with height restrictions and falls in land.'} />

                        </div>
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'General Scope of Work'} label={'List down the scope of work in detail.'} />
                            <CheckMarkSection title={'Specifications for Non-standard Fixtures / Products'} label={'E.g. painted rails, gate, mid rails, door magnet, non-slip paint, FRP Grating Walkway, any non-standard items, etc. If opting not to use standard MAM fixtures/products, list the product name, product code, prime cost and web link.'} />

                            <div style={{ marginTop: '50px' }}><img src={PopupArrow} style={{ marginBottom: '-4px', width: '24px', height: '24px', marginRight: '4px' }} /> <span style={{ color: '#E6722A', }} className="hover" onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2024/09/QR_Ramp_V1.pdf')}>View example </span> <span style={{ color: '#7B7B7B' }}> of a major ramp modification quote request.</span></div>


                        </div>
                    </div>
                </div>}

                {haveAllInfoRamps === 'Yes' ? <>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={rampsPropertyType} setChosenOption={setRampsPropertyType} />


                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([RampsScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={rampsGeneralScope} setChosenOption={setRampsGeneralScope} />

                    {!rampsGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        rampsGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'rampsScopePhotos'} images={rampsScopePhotos} updateImage={(doc) => setRampsScopePhotos(doc)} />
                            : rampsGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{rampsGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('rampsGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={rampsGeneralScopeValue} onChange={(e) => setRampsGeneralScopeValue(e.target.value)}></textarea>)

                    }


                    <label className="question">Upload existing plan & proposed plan with detailed measurements * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}><span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([RampExisting, RampProposed]); setModalTitle('Detailed Measurements') }}>View an example </span> with detailed measurements and marked-up photos.  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'rampsProposedPhotosWithMeasurements'} images={rampsProposedPhotosWithMeasurements} updateImage={(doc) => setRampsProposedPhotosWithMeasurements(doc)} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Upload photos of proposed area * </label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([RampsProposed1, RampsProposed2]); setModalTitle('Proposed Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'rampsProposedPhotos'} images={rampsProposedPhotos} updateImage={(doc) => setRampsProposedPhotos(doc)} />

                        </div>
                        <div className="row-block">
                            <label className="question">Upload photos of entire area from a distance *</label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([RampsDistance1, RampsDistance2]); setModalTitle('Distance Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'rampsExistingPhotos'} images={rampsExistingPhotos} updateImage={(doc) => setRampsExistingPhotos(doc)} />
                        </div>
                    </div>

                    <label className="question">Any specific requirements?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsRamps} onChange={(e) => setSpecificRequirementsRamps(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>

                </> : haveAllInfoRamps === 'No' && <>






                    <IconBlocks icon={InHouseDrafting} title={'Discover Our Premier In-House Drafting Service.'}>
                        <label style={{ color: '#5E5E5E' }}>Our expert draftsperson will visit your site, gather all necessary information, and propose tailored solutions that meet your clients' needs, site conditions, and construction materials. Want to find out more? Check our  <span className="hover" style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/service/major-modifications/draftsperson-service/', '_blank')}> draftsperson page</span> on our website or view our <span className='hover' style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2022/09/Schedule-of-Rates-DRAFTSPERSON-Ver-4-26-March-2024.pdf', '_blank')}>draftsperson's schedule of rates.</span>
                        </label>

                        <label style={{ marginTop: '20px', color: '#5E5E5E' }}>Simply fill out the pre-appointment information below, and we will send a quote for the draftsperson's service. It’s that easy!</label>


                    </IconBlocks>

                    <label className="sectionHeading">Draftsperson pre-appointment information</label>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={rampsPropertyType} setChosenOption={setRampsPropertyType} />

                    <label className="question">Do you require a joint Visit with OT/Client? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsJointVisit')} options={['Joint visit with OT', 'Joint visit with client only', 'Joint visit with family members']} chosenOption={rampsJointVisit} setChosenOption={setRampsJointVisit} />

                    <label className="question">Location *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsLocation')} options={['Ground Floor', 'Other']} chosenOption={rampsLocation} setChosenOption={setRampsLocation} />

                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([RampsScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={rampsGeneralScope} setChosenOption={setRampsGeneralScope} />

                    {!rampsGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        rampsGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'rampsScopePhotos'} images={rampsScopePhotos} updateImage={(doc) => setRampsScopePhotos(doc)} />
                            : rampsGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{rampsGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('rampsGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={rampsGeneralScopeValue} onChange={(e) => setRampsGeneralScopeValue(e.target.value)}></textarea>)

                    }

                    <label className="question">Upload photos of the proposed work area * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>Photos with mark-up of location & measure preferred.  View examples of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([RampExisting, RampProposed]); setModalTitle('Detailed Measurements') }}>photos.</span>  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'rampsProposedPhotos'} images={rampsProposedPhotos} updateImage={(doc) => setRampsProposedPhotos(doc)} />


                    <div className="row halfWidth">
                        <Input disabled={showSummary} type={'number'} errorMessage={errors.map(({ name }) => name).includes('riseToDoorEntryRamps') && errors.find(({ name }) => name === 'riseToDoorEntryRamps').message} errors={errors} name={'riseToDoorEntryRamps'} value={riseToDoorEntryRamps} setValue={setRiseToDoorEntryRamps} label={'Total rise to door entry (mm)'} />
                        <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('rampGradient') && errors.find(({ name }) => name === 'rampGradient').message} errors={errors} name={'rampGradient'} value={rampGradient} setValue={setRampGradient} label={'Proposed gradient of ramp *'} />
                    </div>

                    <label className="question">Landing at the top of the ramp *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsLandingTop')} options={['New Level Entry Landing', 'Use Existing Landing', 'Extend Existing Landing']} chosenOption={rampsLandingTop} setChosenOption={setRampsLandingTop} />

                    <label className="question">Ramp Threshold *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsThreshold')} options={['Internal Side Only', 'External Side Only', 'Both Internal & External Sides', 'Not Required']} chosenOption={rampsThreshold} setChosenOption={setRampsThreshold} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Concrete landing at the bottom of the ramp? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsConcreteLandingRequired')} options={['Yes', 'No']} chosenOption={rampsConcreteLandingRequired} setChosenOption={setRampsConcreteLandingRequired} />
                            <label className="question">How long will the modification be required for? * </label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsLongRequired')} options={['Permanent', 'Temporary']} chosenOption={rampsLongRequired} setChosenOption={setRampsLongRequired} />


                        </div>
                        <div className="row-block">

                            <label className="question">Concrete path required? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsConcretePathRequired')} options={['Yes', 'No']} chosenOption={rampsConcretePathRequired} setChosenOption={setRampsConcretePathRequired} />
                            <label className="question">Does the client own the house? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('rampsClientOwnHouse')} options={['Owned', 'Rented']} chosenOption={rampsClientOwnHouse} setChosenOption={setRampsClientOwnHouse} />

                        </div>
                    </div>

                    <label className="question">Any additional comments?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsRamps} onChange={(e) => setSpecificRequirementsRamps(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>

                </>}

            </>
        }







        {
            ((showSummary && (!showSection || (showSection && showSection === 'Major Steps')) && pageSequence.includes('Major Steps')) || pageSequence[page] === 'Major Steps') && <>
                <label className="sectionHeading">Steps/Platform Steps Modification Details</label>
                <label className="question">Do you have all the required information and photos for the quote?</label>

                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('haveAllInfoSteps')} options={['Yes', 'No']} chosenOption={haveAllInfoSteps} toggle setChosenOption={setHaveAllInfoSteps} />



                {!haveAllInfoSteps && <div className="explainer-box">
                    <label className="question" style={{ color: '#3F3F3F', textAlign: 'center', fontWeight: '500' }}>Quote Application Requirements for Major Steps Modifications</label>

                    <div className="explainer-box-container">
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'Plans'} label={'Existing plan & proposed plan with detailed measurements.'} />
                            <CheckMarkSection title={'Existing Photos'} label={'Existing photos of the proposed area including a photo of the entire area from a distance to look for potential issues with height restrictions and falls in land.'} />

                        </div>
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'General Scope of Work'} label={'List down the scope of work in detail.'} />
                            <CheckMarkSection title={'Specifications for Non-standard Fixtures / Products'} label={'E.g. painted rails, gate, mid rails, door magnet, non-slip paint, FRP Grating Walkway, any non-standard items, etc. If opting not to use standard MAM fixtures/products, list the product name, product code, prime cost and web link.'} />

                            <div style={{ marginTop: '50px' }}><img src={PopupArrow} style={{ marginBottom: '-4px', width: '24px', height: '24px', marginRight: '4px' }} /> <span style={{ color: '#E6722A', }} className="hover" onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2024/09/QR_Steps_V1.pdf')}>View example </span> <span style={{ color: '#7B7B7B' }}> of a major step modification quote request.</span></div>

                        </div>
                    </div>
                </div>}

                {haveAllInfoSteps === 'Yes' ? <>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={stepsPropertyType} setChosenOption={setStepsPropertyType} />


                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([StepsScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={stepsGeneralScope} setChosenOption={setStepsGeneralScope} />

                    {!stepsGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        stepsGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'stepsScopePhotos'} images={stepsScopePhotos} updateImage={(doc) => setStepsScopePhotos(doc)} />
                            : stepsGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{stepsGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('stepsGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={stepsGeneralScopeValue} onChange={(e) => setStepsGeneralScopeValue(e.target.value)}></textarea>)

                    }


                    <label className="question">Upload existing plan & proposed plan with detailed measurements * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}><span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([StepsExisting, StepsProposed]); setModalTitle('Detailed Measurements') }}>View an example </span> with detailed measurements and marked-up photos.  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'stepsProposedPhotosWithMeasurements'} images={stepsProposedPhotosWithMeasurements} updateImage={(doc) => setStepsProposedPhotosWithMeasurements(doc)} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Upload photos of proposed area * </label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([StepsProposed1, StepsProposed2]); setModalTitle('Proposed Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'stepsProposedPhotos'} images={stepsProposedPhotos} updateImage={(doc) => setStepsProposedPhotos(doc)} />

                        </div>
                        <div className="row-block">
                            <label className="question">Upload photos of entire area from a distance *</label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([StepsDistance1, StepsDistance2]); setModalTitle('Distance Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'stepsExistingPhotos'} images={stepsExistingPhotos} updateImage={(doc) => setStepsExistingPhotos(doc)} />
                        </div>
                    </div>

                    <label className="question">Any specific requirements?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsSteps} onChange={(e) => setSpecificRequirementsSteps(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>

                </> : haveAllInfoSteps === 'No' && <>


                    <IconBlocks icon={InHouseDrafting} title={'Discover Our Premier In-House Drafting Service.'}>
                        <label style={{ color: '#5E5E5E' }}>Our expert draftsperson will visit your site, gather all necessary information, and propose tailored solutions that meet your clients' needs, site conditions, and construction materials. Want to find out more? Check our  <span className="hover" style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/service/major-modifications/draftsperson-service/', '_blank')}> draftsperson page</span> on our website or view our <span className='hover' style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2022/09/Schedule-of-Rates-DRAFTSPERSON-Ver-4-26-March-2024.pdf', '_blank')}>draftsperson's schedule of rates.</span>
                        </label>

                        <label style={{ marginTop: '20px', color: '#5E5E5E' }}>Simply fill out the pre-appointment information below, and we will send a quote for the draftsperson's service. It’s that easy!</label>


                    </IconBlocks>

                    <label className="sectionHeading">Draftsperson pre-appointment information</label>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={stepsPropertyType} setChosenOption={setStepsPropertyType} />

                    <label className="question">Do you require a joint Visit with OT/Client? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsJointVisit')} options={['Joint visit with OT', 'Joint visit with client only', 'Joint visit with family members']} chosenOption={stepsJointVisit} setChosenOption={setStepsJointVisit} />

                    <label className="question">Location *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsLocation')} options={['Front of property', 'Rear of property', 'Side of property']} chosenOption={stepsLocation} setChosenOption={setStepsLocation} />

                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([StepsScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={stepsGeneralScope} setChosenOption={setStepsGeneralScope} />

                    {!stepsGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        stepsGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'stepsScopePhotos'} images={stepsScopePhotos} updateImage={(doc) => setStepsScopePhotos(doc)} />
                            : stepsGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{stepsGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('stepsGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={stepsGeneralScopeValue} onChange={(e) => setStepsGeneralScopeValue(e.target.value)}></textarea>)

                    }

                    <label className="question">Upload photos of the proposed work area * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>Photos with mark-up of location & measure preferred.  View examples of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([StepsProposed1, StepsProposed2]); setModalTitle('Proposed Photos') }}>photos.</span>  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'stepsProposedPhotos'} images={stepsProposedPhotos} updateImage={(doc) => setStepsProposedPhotos(doc)} />

                    <div className="row">
                        <div className="row-block">
                            <label className="question">What type of steps? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsType')} options={['Platform steps', 'Tread steps']} chosenOption={stepsType} setChosenOption={setStepsType} />
                        </div>
                        <div className="row halfWidth">
                            <Input disabled={showSummary} type={'number'} errorMessage={errors.map(({ name }) => name).includes('riseToDoorEntrySteps') && errors.find(({ name }) => name === 'riseToDoorEntrySteps').message} errors={errors} name={'riseToDoorEntrySteps'} value={riseToDoorEntrySteps} setValue={setRiseToDoorEntrySteps} label={'Total rise to door entry (mm)'} />
                            <Input disabled={showSummary} type={'text'} errorMessage={errors.map(({ name }) => name).includes('riseOfSteps') && errors.find(({ name }) => name === 'riseOfSteps').message} errors={errors} name={'riseOfSteps'} value={riseOfSteps} setValue={setRiseOfSteps} label={'Rise of steps to achieve? (mm) *'} />
                        </div>
                    </div>

                    <label className="question">Landing at the top of the ramp *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsLandingTop')} options={['New Level Entry Landing', 'Use Existing Landing', 'Extend Existing Landing']} chosenOption={stepsLandingTop} setChosenOption={setStepsLandingTop} />

                    <label className="question">Ramp Threshold *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsThreshold')} options={['Internal Side Only', 'External Side Only', 'Both Internal & External Sides', 'Not Required']} chosenOption={stepsThreshold} setChosenOption={setStepsThreshold} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Concrete landing at the bottom of the ramp? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsConcreteLandingRequired')} options={['Yes', 'No']} chosenOption={stepsConcreteLandingRequired} setChosenOption={setStepsConcreteLandingRequired} />
                            <label className="question">How long will the modification be required for? * </label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsLongRequired')} options={['Permanent', 'Temporary']} chosenOption={stepsLongRequired} setChosenOption={setStepsLongRequired} />


                        </div>
                        <div className="row-block">

                            <label className="question">Concrete path required? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsConcretePathRequired')} options={['Yes', 'No']} chosenOption={stepsConcretePathRequired} setChosenOption={setStepsConcretePathRequired} />
                            <label className="question">Does the client own the house? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stepsClientOwnHouse')} options={['Owned', 'Rented']} chosenOption={stepsClientOwnHouse} setChosenOption={setStepsClientOwnHouse} />

                        </div>
                    </div>

                    <label className="question">Any additional comments?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsSteps} onChange={(e) => setSpecificRequirementsSteps(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>


                </>}

            </>
        }



        {
            ((showSummary && (!showSection || (showSection && showSection === 'Banister Make On-Site')) && pageSequence.includes('Banister Make On-Site')) || pageSequence[page] === 'Banister Make On-Site') && <>
                <label className="sectionHeading">Make On-site Banister Modification Details</label>



                <label className="question">Property Type * </label>
                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('barristerPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={barristerPropertyType} setChosenOption={setBarristerPropertyType} />


                <label className="question">How would you prefer to submit the general scope of work description? * </label>
                <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([BarristerScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('barristerGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={barristerGeneralScope} setChosenOption={setBarristerGeneralScope} />

                {!barristerGeneralScope && <div style={{ marginTop: '20px' }} />}

                {
                    barristerGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'barristerScopePhotos'} images={barristerScopePhotos} updateImage={(doc) => setBarristerScopePhotos(doc)} />
                        : barristerGeneralScope === 'Text Box in this Form' &&
                        (showSummary ?
                            <p style={{ whiteSpace: 'break-spaces' }}>{barristerGeneralScopeValue}</p>
                            :
                            <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('barristerGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={barristerGeneralScopeValue} onChange={(e) => setBarristerGeneralScopeValue(e.target.value)}></textarea>)

                }


                <label className="question">Upload existing plan & proposed plan with detailed measurements * </label>
                <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}><span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([BarristerMarkedUp1, BarristerMarkedUp2]); setModalTitle('Detailed Measurements') }}>View an example </span> with detailed measurements and marked-up photos.  </label>
                <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'barristerProposedPhotosWithMeasurements'} images={barristerProposedPhotosWithMeasurements} updateImage={(doc) => setBarristerProposedPhotosWithMeasurements(doc)} />


                <div className="row">
                    <div className="row-block">
                        <label className="question">Upload photos of proposed area * </label>
                        <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([BarristerMarkedUp1, BarristerMarkedUp2]); setModalTitle('Proposed Area') }}>required photos.</span>  </label>
                        <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'barristerProposedPhotos'} images={barristerProposedPhotos} updateImage={(doc) => setBarristerProposedPhotos(doc)} />

                    </div>
                    <div className="row-block">
                        <label className="question">Upload photos of entire area from a distance *</label>
                        <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([BarristerDistance1, BarristerDistance2]); setModalTitle('Distance Photos') }}>required photos.</span>  </label>
                        <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'barristerExistingPhotos'} images={barristerExistingPhotos} updateImage={(doc) => setBarristerExistingPhotos(doc)} />
                    </div>
                </div>

                <label className="question">Any specific requirements?</label>
                <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsBarrister} onChange={(e) => setSpecificRequirementsBarrister(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>


            </>
        }




        {
            ((showSummary && (!showSection || (showSection && showSection === 'Concreting')) && pageSequence.includes('Concreting')) || pageSequence[page] === 'Concreting') && <>
                <label className="sectionHeading">Concrete Works Modification Details</label>
                <label className="question">Do you have all the required information and photos for the quote?</label>

                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('haveAllInfoConcrete')} options={['Yes', 'No']} chosenOption={haveAllInfoConcrete} toggle setChosenOption={setHaveAllInfoConcrete} />



                {!haveAllInfoConcrete && <div className="explainer-box">
                    <label className="question" style={{ color: '#3F3F3F', textAlign: 'center', fontWeight: '500' }}>Quote Application Requirements for Concreting Modifications</label>

                    <div className="explainer-box-container">
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'Plans'} label={'Existing plan & proposed plan with detailed measurements.'} />
                            <CheckMarkSection title={'Existing Photos'} label={'Existing photos of the proposed area including a photo of the entire area from a distance to look for potential issues with height restrictions and falls in land.'} />

                        </div>
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'General Scope of Work'} label={'List down the scope of work in detail.'} />
                            <CheckMarkSection title={'Specifications for Non-standard Fixtures / Products'} label={'E.g. painted rails, gate, mid rails, door magnet, non-slip paint, FRP Grating Walkway, any non-standard items, etc. If opting not to use standard MAM fixtures/products, list the product name, product code, prime cost and web link.'} />

                            <div style={{ marginTop: '50px' }}><img src={PopupArrow} style={{ marginBottom: '-4px', width: '24px', height: '24px', marginRight: '4px' }} /> <span style={{ color: '#E6722A', }} className="hover" onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2024/09/QR_Concrete-Works_V1.pdf')}>View examples </span> <span style={{ color: '#7B7B7B' }}>  of a concrete quote request.</span></div>

                        </div>
                    </div>
                </div>}

                {haveAllInfoConcrete === 'Yes' ? <>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concretePropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={concretePropertyType} setChosenOption={setConcretePropertyType} />

                    {/* <label className="question">Floor Level * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concreteFloorLevel')} options={['Ground Floor', 'Other']} chosenOption={concreteFloorLevel} setChosenOption={setConcreteFloorLevel} /> */}


                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([ConcreteScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concreteGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={concreteGeneralScope} setChosenOption={setConcreteGeneralScope} />

                    {!concreteGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        concreteGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'concreteScopePhotos'} images={concreteScopePhotos} updateImage={(doc) => setConcreteScopePhotos(doc)} />
                            : concreteGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{concreteGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('concreteGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={concreteGeneralScopeValue} onChange={(e) => setConcreteGeneralScopeValue(e.target.value)}></textarea>)

                    }


                    <label className="question">Upload existing plan & proposed plan with detailed measurements * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}><span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([ConcreteProposed]); setModalTitle('Detailed Measurements') }}>View an example </span> with detailed measurements and marked-up photos.  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'concreteProposedPhotosWithMeasurements'} images={concreteProposedPhotosWithMeasurements} updateImage={(doc) => setConcreteProposedPhotosWithMeasurements(doc)} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Upload photos of proposed area * </label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([ConcreteProposed1, ConcreteProposed2]); setModalTitle('Proposed Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'concreteProposedPhotos'} images={concreteProposedPhotos} updateImage={(doc) => setConcreteProposedPhotos(doc)} />

                        </div>
                        <div className="row-block">
                            <label className="question">Upload photos of entire area from a distance *</label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([ConcreteDistance1, ConcreteDistance2]); setModalTitle('Distance Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'concreteExistingPhotos'} images={concreteExistingPhotos} updateImage={(doc) => setConcreteExistingPhotos(doc)} />
                        </div>
                    </div>

                    <label className="question">Any specific requirements?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsConcrete} onChange={(e) => setSpecificRequirementsConcrete(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>

                </> : haveAllInfoConcrete === 'No' && <>


                    <IconBlocks icon={InHouseDrafting} title={'Discover Our Premier In-House Drafting Service.'}>
                        <label style={{ color: '#5E5E5E' }}>Our expert draftsperson will visit your site, gather all necessary information, and propose tailored solutions that meet your clients' needs, site conditions, and construction materials. Want to find out more? Check our  <span className="hover" style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/service/major-modifications/draftsperson-service/', '_blank')}> draftsperson page</span> on our website or view our <span className='hover' style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2022/09/Schedule-of-Rates-DRAFTSPERSON-Ver-4-26-March-2024.pdf', '_blank')}>draftsperson's schedule of rates.</span>
                        </label>

                        <label style={{ marginTop: '20px', color: '#5E5E5E' }}>Simply fill out the pre-appointment information below, and we will send a quote for the draftsperson's service. It’s that easy!</label>


                    </IconBlocks>

                    <label className="sectionHeading">Draftsperson pre-appointment information</label>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concretePropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={concretePropertyType} setChosenOption={setConcretePropertyType} />

                    <label className="question">Do you require a joint Visit with OT/Client? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concreteJointVisit')} options={['Joint visit with OT', 'Joint visit with client only', 'Joint visit with family members']} chosenOption={concreteJointVisit} setChosenOption={setConcreteJointVisit} />

                    <label className="question">Location *</label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concreteLocation')} options={['Front of property', 'Rear of property', 'Side of property']} chosenOption={concreteLocation} setChosenOption={setConcreteLocation} />

                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([ConcreteScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concreteGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={concreteGeneralScope} setChosenOption={setConcreteGeneralScope} />

                    {!concreteGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        concreteGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'concreteScopePhotos'} images={concreteScopePhotos} updateImage={(doc) => setConcreteScopePhotos(doc)} />
                            : concreteGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{concreteGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('concreteGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={concreteGeneralScopeValue} onChange={(e) => setConcreteGeneralScopeValue(e.target.value)}></textarea>)

                    }

                    <label className="question">Upload photos of the proposed work area * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>Photos with mark-up of location & measure preferred.  View examples of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([ConcreteProposed1, ConcreteProposed2]); setModalTitle('Proposed Photos') }}>photos.</span>  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'concreteProposedPhotos'} images={concreteProposedPhotos} updateImage={(doc) => setConcreteProposedPhotos(doc)} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Match Concrete Colour to Existing? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('matchConcreteColor')} options={['Yes', 'No']} chosenOption={matchConcreteColor} setChosenOption={setMatchConcreteColor} />
                            <label className="question">Removal & disposal of plants/shrubs/garden beds? * </label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('removalPlantsConcrete')} options={['Yes', 'No']} chosenOption={removalPlantsConcrete} setChosenOption={setRemovalPlantsConcrete} />
                            <label className="question">Storm water pits required? * </label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('stormWaterPitsRequired')} options={['Yes', 'No']} chosenOption={stormWaterPitsRequired} setChosenOption={setStormWaterPitsRequired} />

                        </div>
                        <div className="row-block">

                            <label className="question">Do Pavers need to be relayed? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('paversNeedRelay')} options={['Yes', 'No']} chosenOption={paversNeedRelay} setChosenOption={setPaversNeedRelay} />
                            <label className="question">Removal & disposal of trees? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('disposalOfTrees')} options={['Owned', 'Rented']} chosenOption={disposalOfTrees} setChosenOption={setDisposalOfTrees} />
                            <label className="question">Does the client own the house? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('concreteClientOwnHouse')} options={['Owned', 'Rented']} chosenOption={concreteClientOwnHouse} setChosenOption={setConcreteClientOwnHouse} />

                        </div>
                    </div>

                    <label className="question">Any additional comments?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsConcrete} onChange={(e) => setSpecificRequirementsConcrete(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>


                </>}

            </>
        }


        {
            ((showSummary && (!showSection || (showSection && showSection === 'Internal Door Modification')) && pageSequence.includes('Internal Door Modification')) || pageSequence[page] === 'Internal Door Modification') && <>
                <label className="sectionHeading">Internal Door Modification Details</label>
                <label className="question">Do you have all the required information and photos for the quote?</label>

                <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('haveAllInfoDoorway')} options={['Yes', 'No']} chosenOption={haveAllInfoDoorway} toggle setChosenOption={setHaveAllInfoDoorway} />



                {!haveAllInfoDoorway && <div className="explainer-box">
                    <label className="question" style={{ color: '#3F3F3F', textAlign: 'center', fontWeight: '500' }}>Quote Application Requirements for Internal Door Modifications</label>

                    <div className="explainer-box-container">
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'Plans'} label={'Existing plan & proposed plan with detailed measurements.'} />
                            <CheckMarkSection title={'Existing Photos'} label={'Existing photos of the proposed area including a photo of the entire area from a distance to look for potential issues with height restrictions and falls in land.'} />

                        </div>
                        <div className="explainer-box-columns">

                            <CheckMarkSection title={'General Scope of Work'} label={'List down the scope of work in detail.'} />
                            <CheckMarkSection title={'Specifications for Non-standard Fixtures / Products'} label={'E.g. painted rails, gate, mid rails, door magnet, non-slip paint, FRP Grating Walkway, any non-standard items, etc. If opting not to use standard MAM fixtures/products, list the product name, product code, prime cost and web link.'} />

                            <div style={{ marginTop: '50px' }}><img src={PopupArrow} style={{ marginBottom: '-4px', width: '24px', height: '24px', marginRight: '4px' }} /> <span style={{ color: '#E6722A', }} className="hover" onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2024/09/QR_Internal-Door_V1.pdf')}>View example </span> <span style={{ color: '#7B7B7B' }}> of an internal door quote request.</span></div>

                        </div>
                    </div>
                </div>}

                {haveAllInfoDoorway === 'Yes' ? <>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorwayPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={doorwayPropertyType} setChosenOption={setDoorwayPropertyType} />


                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([InternalScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorwayGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={doorwayGeneralScope} setChosenOption={setDoorwayGeneralScope} />

                    {!doorwayGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        doorwayGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'doorwayScopePhotos'} images={doorwayScopePhotos} updateImage={(doc) => setDoorwayScopePhotos(doc)} />
                            : doorwayGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{doorwayGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('doorwayGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={doorwayGeneralScopeValue} onChange={(e) => setDoorwayGeneralScopeValue(e.target.value)}></textarea>)

                    }


                    <label className="question">Upload existing plan & proposed plan with detailed measurements * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}><span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([InternalScope]); setModalTitle('Detailed Measurements') }}>View an example </span> with detailed measurements and marked-up photos.  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'doorwayProposedPhotosWithMeasurements'} images={doorwayProposedPhotosWithMeasurements} updateImage={(doc) => setDoorwayProposedPhotosWithMeasurements(doc)} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Upload photos of proposed area * </label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([InternalProposed1, InternalProposed2]); setModalTitle('Proposed Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'doorwayProposedPhotos'} images={doorwayProposedPhotos} updateImage={(doc) => setDoorwayProposedPhotos(doc)} />

                        </div>
                        <div className="row-block">
                            <label className="question">Upload photos of entire area from a distance *</label>
                            <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([InternalDistance1, InternalDistance2]); setModalTitle('Distance Photos') }}>required photos.</span>  </label>
                            <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'doorwayExistingPhotos'} images={doorwayExistingPhotos} updateImage={(doc) => setDoorwayExistingPhotos(doc)} />
                        </div>
                    </div>

                    <label className="question">Any specific requirements?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsDoorway} onChange={(e) => setSpecificRequirementsDoorway(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>

                </> : haveAllInfoDoorway === 'No' && <>

                    <IconBlocks icon={InHouseDrafting} title={'Discover Our Premier In-House Drafting Service.'}>
                        <label style={{ color: '#5E5E5E' }}>Our expert draftsperson will visit your site, gather all necessary information, and propose tailored solutions that meet your clients' needs, site conditions, and construction materials. Want to find out more? Check our  <span className="hover" style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/service/major-modifications/draftsperson-service/', '_blank')}> draftsperson page</span> on our website or view our <span className='hover' style={{ color: '#E6722A', fontWeight: '600' }} onClick={() => window.open('https://mobilityaccess.com.au/wp-content/uploads/2022/09/Schedule-of-Rates-DRAFTSPERSON-Ver-4-26-March-2024.pdf', '_blank')}>draftsperson's schedule of rates.</span>
                        </label>

                        <label style={{ marginTop: '20px', color: '#5E5E5E' }}>Simply fill out the pre-appointment information below, and we will send a quote for the draftsperson's service. It’s that easy!</label>


                    </IconBlocks>

                    <label className="sectionHeading">Draftsperson pre-appointment information</label>
                    <label className="question">Property Type * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorwayPropertyType')} options={['Stand Alone House', 'Townhouse', 'Apartment', 'Other']} chosenOption={doorwayPropertyType} setChosenOption={setDoorwayPropertyType} />

                    <label className="question">Do you require a joint Visit with OT/Client? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorwayJointVisit')} options={['Joint visit with OT', 'Joint visit with client only', 'Joint visit with family members']} chosenOption={doorwayJointVisit} setChosenOption={setDoorwayJointVisit} />


                    <label className="question">How would you prefer to submit the general scope of work description? * </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>View an example of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([InternalScope]); setModalTitle('Scope of Works') }}>scope of works.</span> </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorwayGeneralScope')} options={['Upload File', 'Text Box in this Form']} chosenOption={doorwayGeneralScope} setChosenOption={setDoorwayGeneralScope} />

                    {!doorwayGeneralScope && <div style={{ marginTop: '20px' }} />}

                    {
                        doorwayGeneralScope === 'Upload File' ? <MyDropzone disabled={showSummary} addMarginTop storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'doorwayScopePhotos'} images={doorwayScopePhotos} updateImage={(doc) => setDoorwayScopePhotos(doc)} />
                            : doorwayGeneralScope === 'Text Box in this Form' &&
                            (showSummary ?
                                <p style={{ whiteSpace: 'break-spaces' }}>{doorwayGeneralScopeValue}</p>
                                :
                                <textarea disabled={showSummary} className={errors.map(({ name }) => name).includes('doorwayGeneralScopeValue') ? 'error' : ''} style={{ marginTop: 20, width: '100%', height: '100px' }} value={doorwayGeneralScopeValue} onChange={(e) => setDoorwayGeneralScopeValue(e.target.value)}></textarea>)

                    }

                    <label className="question">Upload photos of the proposed work area from both sides of door* </label>
                    <label style={{ color: '#7B7B7B', marginBottom: '20px', marginTop: '-5px' }}>  View examples of required <span style={{ color: '#E6722A' }} className="hover" onClick={() => { setShowPopup(true); setModalContent([InternalProposed1, InternalProposed2]); setModalTitle('Proposed Photos') }}>photos.</span>  </label>
                    <MyDropzone disabled={showSummary} storageLocation={`mam-quotes/`} customMessage={'Drop files here to upload'} errors={errors} name={'doorwayProposedPhotos'} images={doorwayProposedPhotos} updateImage={(doc) => setDoorwayProposedPhotos(doc)} />


                    <label className="question">Location? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorwayLocation')} options={['Bathroom', 'Bedroom', 'Hallway', 'Kitchen', 'Laundry']} chosenOption={doorwayLocation} setChosenOption={setDoorwayLocation} />


                    <div className="row">
                        <div className="row-block">
                            <label className="question">Infill existing door opening? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('infillDoorOpening')} options={['Yes', 'No']} chosenOption={infillDoorOpening} setChosenOption={setInfillDoorOpening} />
                            <label className="question">Create New Wall Opening? * </label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('createWallOpening')} options={['Yes', 'No']} chosenOption={createWallOpening} setChosenOption={setCreateWallOpening} />

                        </div>
                        <div className="row-block">

                            <label className="question">Do you require door widening? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorWidening')} options={['Yes', 'No']} chosenOption={doorWidening} setChosenOption={setDoorWidening} />
                            <label className="question">Does the client own the house? *</label>
                            <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorwayClientOwnHouse')} options={['Owned', 'Rented']} chosenOption={doorwayClientOwnHouse} setChosenOption={setDoorwayClientOwnHouse} />


                        </div>
                    </div>

                    <label className="question">Door type? * </label>
                    <Options disabled={showSummary} error={errors.map(({ name }) => name).includes('doorType')} options={['Cavity slider', 'Swing door', 'External slider']} chosenOption={doorType} setChosenOption={setDoorType} />


                    <label className="question">Any additional comments?</label>
                    <textarea disabled={showSummary} style={{ width: '100%', height: '100px' }} value={specificRequirementsConcrete} onChange={(e) => setSpecificRequirementsConcrete(e.target.value)} placeholder="Specifications for any non-standard items, including product codes and prime costs if opting not to use standard MAM products."></textarea>


                </>}

            </>
        }



        {!showSummary && <div className="row" style={{ justifyContent: 'flex-start', gap: '20px' }}>
            <button className="primary-button" disabled={loading} onClick={handleNextPage}>{(page !== pageSequence.length - 1 || (page === 1 && (!modificationType || modificationType === 'Major'))) ? 'Continue' : 'Submit'}</button>
            {page !== 0 && <button className="secondary-button" disabled={loading} onClick={() => setPage(page - 1)} >Previous</button>}
        </div>}
    </div >)
}

export default Dashboard